import * as React from 'react';
import React__default, { useCallback, useRef, useState, useEffect, useMemo, useReducer, useContext } from 'react';
import PropTypes from 'prop-types';
import { useField, useFormState, useForm } from 'react-final-form';
import axios from 'axios';
import { setIn, getIn } from 'final-form';
import { isEmpty as isEmpty$1, get, isEqual, groupBy, isArray as isArray$1 } from 'lodash';
import { useLocation, matchPath, Link, useHistory } from 'react-router-dom';
import { useLongPress } from 'use-long-press';

function _extends$A() {
  _extends$A = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$A.apply(this, arguments);
}

const RawTextInput = (_ref, ref) => {
  let {
    noDefaultClass = false,
    required,
    ...props
  } = _ref;
  return /*#__PURE__*/React__default.createElement("input", _extends$A({
    type: "text",
    "data-testid": "raw-text-input"
  }, props, {
    ref: ref,
    "aria-invalid": props.error ? true : false,
    id: props.id,
    "aria-describedby": "".concat(props.id, "-hint"),
    className: "".concat(!noDefaultClass ? 'form-control' : '', " ").concat(props.className ? props.className : ''),
    tabIndex: props.noTabIndex ? -1 : 0,
    "aria-required": required
  }));
};
var RawTextInput$1 = /*#__PURE__*/React__default.forwardRef(RawTextInput);
RawTextInput.propTypes = {
  className: PropTypes.string,
  noDefaultClass: PropTypes.bool,
  id: PropTypes.string,
  error: PropTypes.string,
  noTabIndex: PropTypes.bool,
  required: PropTypes.bool
};

const FeedbackMessage = _ref => {
  let {
    feedbackMessage = '',
    id = '',
    error = true
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "d-block ".concat(error ? 'error' : 'message', "-feedback tj-error-message"),
    "data-testid": "feedback-message",
    id: id
  }, feedbackMessage);
};
FeedbackMessage.propTypes = {
  feedbackMessage: PropTypes.string.isRequired,
  id: PropTypes.string,
  error: PropTypes.bool
};

const toolTipPropTypes = {
  disabled: PropTypes.bool,
  place: PropTypes.oneOf(['top', 'bottom', 'right', 'left']),
  event: PropTypes.oneOf(['hover', 'click']),
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};

const TooltipMessage = _ref => {
  let {
    message,
    place
  } = _ref;
  const arrowClass = useCallback(() => {
    if (place === 'top') {
      return 'down';
    } else if (place === 'bottom') {
      return 'up';
    } else {
      return place;
    }
  }, [place]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "tj-tooltip-content-wrapper ".concat(place)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "tj-tooltip-message",
    "data-testid": "tj-tooltip-message"
  }, message), /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "tj-triangle-".concat(arrowClass()),
    className: "tj-triangle triangle-".concat(arrowClass())
  }));
};
TooltipMessage.propTypes = {
  message: toolTipPropTypes.message,
  place: toolTipPropTypes.place
};

var _g$o;
function _extends$z() { _extends$z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }
const SvgInfoIcon = props => /*#__PURE__*/React.createElement("svg", _extends$z({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g$o || (_g$o = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  mask: "url(#InfoIcon_svg__mask-2)",
  transform: "translate(2 2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h20v20H0z"
})), /*#__PURE__*/React.createElement("g", {
  stroke: "#FFF",
  mask: "url(#InfoIcon_svg__mask-2)",
  transform: "translate(2 2)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(180 7.5 8.5)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 14,
  r: 1,
  fill: "#FFF",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M8 5v5"
}))))));

var _path$a;
function _extends$y() { _extends$y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }
const SvgView = props => /*#__PURE__*/React.createElement("svg", _extends$y({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path$a || (_path$a = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 6c-4.09 0-7.585 2.545-9 6.136 1.415 3.592 4.91 6.137 9 6.137s7.585-2.545 9-6.137C19.585 8.545 16.09 6 12 6m0 10.227a4.09 4.09 0 0 1-4.09-4.09A4.09 4.09 0 0 1 12 8.044a4.09 4.09 0 0 1 4.09 4.091A4.09 4.09 0 0 1 12 16.227m0-6.545a2.45 2.45 0 0 0-2.455 2.454A2.45 2.45 0 0 0 12 14.591a2.45 2.45 0 0 0 2.455-2.455A2.45 2.45 0 0 0 12 9.682"
})));

var _g$n;
function _extends$x() { _extends$x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }
const SvgStopView = props => /*#__PURE__*/React.createElement("svg", _extends$x({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g$n || (_g$n = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.004 7.274a4.094 4.094 0 0 1 4.093 4.093c0 .532-.107 1.031-.295 1.498l2.39 2.39A9.7 9.7 0 0 0 21 11.367c-1.416-3.593-4.911-6.14-9.004-6.14a9.5 9.5 0 0 0-3.258.574l1.768 1.768a4 4 0 0 1 1.498-.295M3.82 5.04l1.866 1.866.376.376A9.66 9.66 0 0 0 3 11.367c1.416 3.593 4.911 6.14 9.004 6.14a9.6 9.6 0 0 0 3.585-.688l.344.343 2.399 2.39 1.04-1.039L4.857 4zm4.526 4.526 1.269 1.269a2.3 2.3 0 0 0-.066.532 2.45 2.45 0 0 0 2.456 2.456c.18 0 .36-.025.532-.066l1.269 1.269a4.06 4.06 0 0 1-1.8.434 4.094 4.094 0 0 1-4.094-4.093c0-.647.164-1.252.434-1.8m3.528-.638 2.579 2.578.016-.13a2.45 2.45 0 0 0-2.456-2.456z"
}))));

var _g$m;
function _extends$w() { _extends$w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }
const SvgUploadCvPictogram = props => /*#__PURE__*/React.createElement("svg", _extends$w({
  xmlns: "http://www.w3.org/2000/svg",
  width: 110,
  height: 101
}, props), _g$m || (_g$m = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero",
  transform: "translate(0 .034)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F2F2F2",
  d: "m56.114 1.18-3.565.924-43.925 11.38-3.565.923c-3.603.938-5.77 4.629-4.845 8.25l15.46 60.226c.933 3.62 4.607 5.798 8.212 4.868l.01-.002 51.036-13.222.01-.003c3.602-.938 5.77-4.629 4.844-8.25L64.326 6.047C63.394 2.428 59.72.25 56.115 1.18"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "m56.573 3.118-4.216 1.093L9.813 15.236 5.597 16.33c-2.562.667-4.103 3.292-3.445 5.868l15.436 60.154c.663 2.574 3.276 4.123 5.84 3.462l.008-.002 50.958-13.207.009-.002c2.562-.667 4.103-3.292 3.445-5.868L62.412 6.58c-.663-2.574-3.276-4.123-5.839-3.462"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F2F2F2",
  d: "M53.16 22.2 27.4 28.93a1.12 1.12 0 0 1-1.364-.816 1.136 1.136 0 0 1 .805-1.383l25.76-6.73a1.12 1.12 0 0 1 1.363.816 1.136 1.136 0 0 1-.804 1.382M59.146 25.163 28.423 32.93a1.14 1.14 0 0 1-1.387-.802 1.114 1.114 0 0 1 .818-1.36l30.723-7.767a1.14 1.14 0 0 1 1.387.802 1.114 1.114 0 0 1-.818 1.36M58.16 39.2 32.4 45.93a1.11 1.11 0 0 1-1.08-.305 1.15 1.15 0 0 1-.279-1.099c.107-.39.412-.693.8-.795l25.759-6.73a1.11 1.11 0 0 1 1.08.305c.28.289.386.708.279 1.099-.107.39-.412.693-.8.795M63.146 42.163 32.423 49.93c-.394.1-.812-.014-1.097-.299a1.1 1.1 0 0 1-.284-1.08c.109-.385.418-.683.812-.782L62.577 40a1.14 1.14 0 0 1 1.387.802 1.114 1.114 0 0 1-.818 1.36M62.16 56.2 36.4 62.93a1.12 1.12 0 0 1-1.364-.816 1.136 1.136 0 0 1 .804-1.382l25.76-6.73a1.12 1.12 0 0 1 1.364.815 1.136 1.136 0 0 1-.805 1.383M68.146 58.163 37.424 65.93c-.394.1-.813-.014-1.098-.299a1.1 1.1 0 0 1-.284-1.08c.109-.385.419-.683.813-.783l30.722-7.767a1.14 1.14 0 0 1 1.387.802 1.114 1.114 0 0 1-.818 1.36"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E6E6E6",
  d: "M22.606 36.503 13.7 38.948c-.28.076-.566-.103-.639-.402l-2.044-8.438c-.072-.298.096-.603.377-.68l8.906-2.445c.28-.076.566.103.639.402l2.044 8.438c.072.298-.096.603-.377.68M27.606 52.503 18.7 54.948c-.28.076-.566-.103-.639-.402l-2.044-8.438c-.072-.298.096-.603.377-.68l8.906-2.445c.28-.076.566.103.639.402l2.044 8.438c.072.299-.096.603-.377.68M31.606 69.503 22.7 71.948c-.28.076-.566-.103-.639-.402l-2.044-8.438c-.072-.298.096-.603.377-.68l8.906-2.445c.28-.076.566.103.639.402l2.044 8.438c.072.298-.096.603-.377.68M92.279 15.966H39.72c-3.71.004-6.717 3.044-6.721 6.796V85.17c.004 3.752 3.01 6.792 6.721 6.797H92.28c3.71-.005 6.717-3.045 6.721-6.797V22.762c-.004-3.752-3.01-6.792-6.721-6.796"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M92.224 17.966H39.776C37.14 17.969 35.003 20.13 35 22.8V85.13c.003 2.669 2.14 4.832 4.776 4.835h52.448C94.86 89.962 96.997 87.8 97 85.13V22.8c-.003-2.669-2.14-4.831-4.776-4.834"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97.5,
  cy: 87.466,
  r: 12.5,
  fill: "currentcolor"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M103.393 85.858h-4.286v-4.285a1.607 1.607 0 1 0-3.214 0v4.285h-4.286a1.607 1.607 0 1 0 0 3.215h4.286v4.285a1.607 1.607 0 1 0 3.214 0v-4.285h4.286a1.607 1.607 0 0 0 0-3.215"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E6E6E6",
  d: "M83.875 52.966H57.128c-.403 0-.775-.19-.977-.5a.9.9 0 0 1 0-1c.202-.31.574-.5.977-.5h26.747c.621 0 1.125.448 1.125 1 0 .551-.504.999-1.125 1M88.862 55.966H57.139c-.406 0-.783-.19-.986-.5a.9.9 0 0 1 0-1c.203-.31.58-.5.986-.5h31.723c.628 0 1.138.447 1.138 1s-.51 1-1.138 1M83.874 69.966H57.128c-.403 0-.775-.19-.977-.5a.9.9 0 0 1 0-1c.202-.31.574-.5.977-.5h26.746c.622 0 1.126.447 1.126 1s-.504 1-1.126 1M88.86 73.966H57.14c-.408 0-.784-.19-.987-.5a.9.9 0 0 1 0-1c.203-.31.58-.5.986-.5h31.722c.407 0 .783.19.986.5a.9.9 0 0 1 0 1c-.203.31-.58.5-.986.5M51.437 58.966h-9.874a.566.566 0 0 1-.563-.569v-8.863c0-.314.252-.568.563-.568h9.874c.31 0 .563.254.563.568v8.863a.566.566 0 0 1-.563.569M51.437 75.966h-9.874a.566.566 0 0 1-.563-.569v-8.863c0-.314.252-.568.563-.568h9.874c.31 0 .563.254.563.568v8.863a.566.566 0 0 1-.563.569"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "M83.872 33.966H64.128c-.623 0-1.128-.448-1.128-1 0-.553.505-1 1.128-1h19.744c.623 0 1.128.447 1.128 1s-.505 1-1.128 1M88.857 36.966H64.143c-.409 0-.786-.191-.99-.5a.89.89 0 0 1 0-1c.204-.31.581-.5.99-.5h24.714c.631 0 1.143.447 1.143 1s-.512 1-1.143 1"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  d: "M59.467 41.966H41.533a.53.53 0 0 1-.533-.531V27.496c0-.293.239-.53.533-.53h17.934c.294 0 .533.237.533.53v13.939c0 .293-.239.53-.533.53"
}))));

var _g$l;
function _extends$v() { _extends$v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }
const SvgDeleteIcon = props => /*#__PURE__*/React.createElement("svg", _extends$v({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g$l || (_g$l = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4 4h16v16H4z"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 10v6M14 10v6M6 7v11c.065.527.57 1.004 1.104 1H17c.534.004.935-.473 1-1V7zM4 7h16M9 7V5.017C9 4.5 9.5 4 10 4h4c.5 0 1 .5 1 1.017V7"
})))));

var _g$k;
function _extends$u() { _extends$u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }
const SvgAchievement = props => /*#__PURE__*/React.createElement("svg", _extends$u({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g$k || (_g$k = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  transform: "translate(5 4)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 7.2,
  cy: 5.2,
  r: 5.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.2 10.4a5.19 5.19 0 0 1-4.504-2.616L0 13.696l3.088-.312L4.8 16l2.56-5.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.704 7.784A5.19 5.19 0 0 1 7.2 10.4h-.192L9.6 16l1.744-2.616 3.088.312z"
}))));

var _g$j;
function _extends$t() { _extends$t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }
const SvgAward = props => /*#__PURE__*/React.createElement("svg", _extends$t({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g$j || (_g$j = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.144 11.008c2.312-.296 3.752-3.376 3.816-4.8s-1.344-1.488-3.488-1.496M7.776 11.008C5.464 10.712 4 7.624 4 6.208S5.304 4.72 7.44 4.712"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.48 4v5.272A4.37 4.37 0 0 1 12 13.6a4.37 4.37 0 0 1-4.56-4.328V4zM8.768 18.408h6.496M11.96 13.632v4.776"
}))));

var _g$i;
function _extends$s() { _extends$s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }
const SvgCalendar = props => /*#__PURE__*/React.createElement("svg", _extends$s({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g$i || (_g$i = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentcolor",
  strokeWidth: 1.5,
  transform: "translate(5 4)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  y: 2,
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M4.5.533V4M9.5.533V4"
}))));

var _g$h;
function _extends$r() { _extends$r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }
const SvgChat = props => /*#__PURE__*/React.createElement("svg", _extends$r({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g$h || (_g$h = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M20 11.856A7.944 7.944 0 0 0 12 4a7.944 7.944 0 0 0-8 7.856 7.944 7.944 0 0 0 8 7.856c.9.003 1.792-.149 2.64-.448l4.216.736h.088a.53.53 0 0 0 .408-.184.45.45 0 0 0 .064-.512l-1.12-2.608a8.1 8.1 0 0 0 1.16-1.984A7.7 7.7 0 0 0 20 11.856"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  fillRule: "nonzero",
  d: "M7.8 10.848a1 1 0 1 0 0 2 1 1 0 0 0 0-2M11.8 10.776a1 1 0 1 0 1 1.02 1 1 0 0 0-1-1zM15.848 10.824a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
}))));

var _path$9;
function _extends$q() { _extends$q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }
const SvgCheckbox = props => /*#__PURE__*/React.createElement("svg", _extends$q({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16
}, props), _path$9 || (_path$9 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M3 8.571 6.3 12 13 5"
})));

var _g$g;
function _extends$p() { _extends$p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }
const SvgCreate = props => /*#__PURE__*/React.createElement("svg", _extends$p({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g$g || (_g$g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M4 12h16M12 4v16"
}))));

var _g$f;
function _extends$o() { _extends$o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }
const SvgCross = props => /*#__PURE__*/React.createElement("svg", _extends$o({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g$f || (_g$f = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M6 18 18 6M6 6l12 12"
}))));

var _g$e;
function _extends$n() { _extends$n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }
const SvgDegree = props => /*#__PURE__*/React.createElement("svg", _extends$n({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g$e || (_g$e = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.2 11.376V15.6c1.648.856 3.2 1.6 4.8 1.6h0c1.552 0 3.136-.736 4.8-1.6v-4.224"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 9.92 11.976 6 20 9.92l-8.024 3.544zM4.776 10.352v2.392"
}))));

var _g$d;
function _extends$m() { _extends$m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }
const SvgDownload = props => /*#__PURE__*/React.createElement("svg", _extends$m({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g$d || (_g$d = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 4v10M16 11.02 12 15l-4-3.98M19 19H5"
}))));

var _path$8;
function _extends$l() { _extends$l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }
const SvgDropdownArrowBack = props => /*#__PURE__*/React.createElement("svg", _extends$l({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16
}, props), _path$8 || (_path$8 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M10 4 6 8l4 4"
})));

var _path$7;
function _extends$k() { _extends$k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }
const SvgDropdownArrowDown = props => /*#__PURE__*/React.createElement("svg", _extends$k({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16
}, props), _path$7 || (_path$7 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m4 6 4 4 4-4"
})));

var _path$6;
function _extends$j() { _extends$j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }
const SvgDropdownArrowUp = props => /*#__PURE__*/React.createElement("svg", _extends$j({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16
}, props), _path$6 || (_path$6 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M12 10 8 6l-4 4"
})));

var _g$c;
function _extends$i() { _extends$i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }
const SvgDropdownCross = props => /*#__PURE__*/React.createElement("svg", _extends$i({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16
}, props), _g$c || (_g$c = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "m4 12 8-8M4 4l8 8"
}))));

var _g$b;
function _extends$h() { _extends$h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }
const SvgEdit = props => /*#__PURE__*/React.createElement("svg", _extends$h({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g$b || (_g$b = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.103 6.842 5.53 15.413 4 20l4.587-1.524 8.571-8.579z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m14.103 6.842 1.89-1.882a.67.67 0 0 1 .952 0l2.095 2.088a.693.693 0 0 1 0 .975l-1.882 1.874z"
}))));

var _g$a;
function _extends$g() { _extends$g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }
const SvgFilter = props => /*#__PURE__*/React.createElement("svg", _extends$g({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g$a || (_g$a = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillRule: "nonzero",
  stroke: "currentcolor",
  strokeWidth: 1.5,
  transform: "translate(4 5)"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M0 2.528h16M0 11.472h16"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10.2,
  cy: 2.6,
  r: 2.6
}), /*#__PURE__*/React.createElement("circle", {
  cx: 5.928,
  cy: 11.482,
  r: 2.6
}))));

var _g$9;
function _extends$f() { _extends$f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }
const SvgLock = props => /*#__PURE__*/React.createElement("svg", _extends$f({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g$9 || (_g$9 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M6 10h12c.5 0 1 .5 1 1v7c0 1-1 2-2 2H7c-1 0-2-1-2-2v-7c0-.5.5-1 1-1M8 10V8c0-1.946 1.087-4 4-4 2.72 0 4 2.174 4 4v2M12 13v3"
}))));

var _path$5;
function _extends$e() { _extends$e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }
const SvgNavigationBack = props => /*#__PURE__*/React.createElement("svg", _extends$e({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path$5 || (_path$5 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5,
  d: "m15 6-6 6 6 6"
})));

var _path$4;
function _extends$d() { _extends$d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }
const SvgNavigationBackBold = props => /*#__PURE__*/React.createElement("svg", _extends$d({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4.5,
  d: "m15 6-6 6 6 6"
})));

var _path$3;
function _extends$c() { _extends$c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }
const SvgNavigationUp = props => /*#__PURE__*/React.createElement("svg", _extends$c({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5,
  d: "m18 15-6-6-6 6"
})));

var _defs$3, _g$8;
function _extends$b() { _extends$b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }
const SvgNotificationError = props => /*#__PURE__*/React.createElement("svg", _extends$b({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 24,
  height: 24,
  viewBox: "0 0 20 20"
}, props), _defs$3 || (_defs$3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "notification-error_svg__a",
  cx: 8.333,
  cy: 8.333,
  r: 8.333
}))), _g$8 || (_g$8 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(1.667 1.667)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "notification-error_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#notification-error_svg__a"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#notification-error_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F73E3E",
  d: "M-8.333-8.333H25V25H-8.333z"
})), /*#__PURE__*/React.createElement("g", {
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  mask: "url(#notification-error_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m11.217 5.616-5.768 5.768M11.218 11.384 5.45 5.616"
})))));

var _defs$2, _g$7;
function _extends$a() { _extends$a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }
const SvgNotificationInfo = props => /*#__PURE__*/React.createElement("svg", _extends$a({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 24,
  height: 24,
  viewBox: "0 0 18 18"
}, props), _defs$2 || (_defs$2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "notification-info_svg__a",
  cx: 8.333,
  cy: 8.333,
  r: 8.333
}))), _g$7 || (_g$7 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(.667 .667)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "notification-info_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#notification-info_svg__a"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#2072E6",
  mask: "url(#notification-info_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16.667v16.667H0z"
})), /*#__PURE__*/React.createElement("g", {
  stroke: "#FFF",
  mask: "url(#notification-info_svg__b)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(180 6.25 7.083)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 4.167,
  cy: 10,
  r: 1,
  fill: "#FFF",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M4.167 2.5v4.167"
}))))));

var _defs$1, _g$6;
function _extends$9() { _extends$9 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }
const SvgNotificationSuccess = props => /*#__PURE__*/React.createElement("svg", _extends$9({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 24,
  height: 24,
  viewBox: "0 0 20 20"
}, props), _defs$1 || (_defs$1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "notification-success_svg__a",
  cx: 8.333,
  cy: 8.333,
  r: 8.333
}), /*#__PURE__*/React.createElement("path", {
  id: "notification-success_svg__c",
  d: "M0 0h8.333v8.333H0z"
}))), _g$6 || (_g$6 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(1.667 1.667)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "notification-success_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#notification-success_svg__a"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#notification-success_svg__a",
  fill: "#3AB17D"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#notification-success_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0AAE5D",
  d: "M-8.333-8.333H25V25H-8.333z"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#notification-success_svg__b)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.167 4.167)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "notification-success_svg__d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#notification-success_svg__c"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m1.25 5 1.806 1.667L7.5 2.5",
  mask: "url(#notification-success_svg__d)"
}))))));

var _defs, _g$5;
function _extends$8() { _extends$8 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }
const SvgNotificationWarning = props => /*#__PURE__*/React.createElement("svg", _extends$8({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 20,
  height: 20
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "notification-warning_svg__a",
  cx: 8.333,
  cy: 8.333,
  r: 8.333
}))), _g$5 || (_g$5 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(1.667 1.667)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "notification-warning_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#notification-warning_svg__a"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#notification-warning_svg__a",
  fill: "#C8B052"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#notification-warning_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F4C712",
  d: "M-8.333-8.333H25V25H-8.333z"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#notification-warning_svg__b)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(5 1.667)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3.333,
  cy: 11.667,
  r: 1,
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M3.333 2.083V8.75"
}))))));

var _g$4;
function _extends$7() { _extends$7 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }
const SvgPerson = props => /*#__PURE__*/React.createElement("svg", _extends$7({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g$4 || (_g$4 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.488 7.752A3.744 3.744 0 1 1 11.728 4a3.75 3.75 0 0 1 3.76 3.752"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.488 7.752A3.744 3.744 0 1 1 11.728 4a3.75 3.75 0 0 1 3.76 3.752M20 19.973a8.344 8.344 0 0 0-16 0"
})))));

var _g$3;
function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
const SvgRocket = props => /*#__PURE__*/React.createElement("svg", _extends$6({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g$3 || (_g$3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m6.594 14.3-1.28 1.286M9.78 17.546l-1.113 1.12M7.234 16.88l-1.087 1.093"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#6954EC",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M12.36 15.02c.04.21.04.424 0 .633l-.407 2c-.04.187.24.387.387.28l1.333-1a3.53 3.53 0 0 0 1.26-3.666 14 14 0 0 1-2.573 1.753M10.74 9.107a3.47 3.47 0 0 0-3.62 1.26l-.987 1.373c-.106.147.1.433.28.393l2-.413c.205-.04.416-.04.62 0 .484-.924 1.055-1.8 1.707-2.613"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#6954EC",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M18.667 5.333s-3.634.107-5.147 1.02h0l-.047.04-.4.274a19.1 19.1 0 0 0-4.74 6.306l2.734 2.754a18.9 18.9 0 0 0 6.2-4.747c.126-.14.246-.293.36-.447h0c.92-1.533 1.04-5.2 1.04-5.2"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6954EC",
  d: "M15.373 8.621a.995.995 0 0 1 0 1.412.98.98 0 0 1-1.412 0 .995.995 0 0 1 0-1.412 1.01 1.01 0 0 1 1.412 0"
}))));

var _g$2;
function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends$5({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g$2 || (_g$2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "m13.6 13.8 5.637 4.911M15 10.004a5 5 0 1 1-10 0 5 5 0 0 1 10 0"
})))));

var _path$2;
function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
const SvgShare = props => /*#__PURE__*/React.createElement("svg", _extends$4({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M13.417 17.61a1.24 1.24 0 0 1-.322-.886V14.8a.616.616 0 0 0-.472-.634 5.9 5.9 0 0 0-3.504.585 7.9 7.9 0 0 0-2.96 2.047l-.168.18a1.134 1.134 0 0 1-1.76-.147c-.24-.352-.297-.8-.152-1.202.39-1.19 1-2.294 1.8-3.25 2.12-2.503 4.912-3.064 6.92-3.494a.4.4 0 0 0 .296-.407V6.276a1.24 1.24 0 0 1 .322-.885A1.2 1.2 0 0 1 14.263 5c.259 0 .509.095.704.268l4.584 5.225c.285.254.449.621.449 1.007s-.164.753-.45 1.008l-4.583 5.224a1.06 1.06 0 0 1-.704.268 1.2 1.2 0 0 1-.846-.39"
})));

var _g$1;
function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
const SvgSkill = props => /*#__PURE__*/React.createElement("svg", _extends$3({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g$1 || (_g$1 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "m8.416 11.728-4.4-4.392 3.232-3.232 4.384 4.384zM15.512 12.368l4.296 4.296-3.232 3.232L12.28 15.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.12 18.736 19.664 8.24c.213-.212.333-.5.336-.8.001-.301-.12-.59-.336-.8l-2.288-2.304a1.11 1.11 0 0 0-.8-.336c-.3.003-.588.123-.8.336L5.6 14.56 4 20zM14.024 6.288l3.688 3.688M6.352 9.336l.88-.872M14.664 17.648l.872-.88"
}), /*#__PURE__*/React.createElement("path", {
  d: "m5.512 14.704 1.92.128v1.736h1.664v2.16"
}))));

var _path$1;
function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends$2({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentcolor",
  strokeWidth: 1.5,
  d: "m12.547 5.7 1.593 3.333c.085.19.26.324.467.354l3.553.54a.667.667 0 0 1 .347 1.1l-2.574 2.6a.67.67 0 0 0-.18.58l.607 3.666a.667.667 0 0 1-.907.667l-3.173-1.733a.6.6 0 0 0-.58 0L8.527 18.54a.667.667 0 0 1-.907-.667l.607-3.666a.67.67 0 0 0-.18-.58l-2.574-2.6a.667.667 0 0 1 .347-1.094l3.553-.54a.61.61 0 0 0 .467-.353l1.587-3.333a.613.613 0 0 1 1.12-.007Z"
})));

var _g;
function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
const SvgThreeDotsInHorizontalLine = props => /*#__PURE__*/React.createElement("svg", _extends$1({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentcolor",
  fillRule: "nonzero",
  transform: "translate(4.5 10.333)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 1.917,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7.75,
  cy: 1.917,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.5,
  cy: 1.917,
  r: 1.5
}))));

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgCheckMark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 8
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M1 3.857 3.64 6.6 9 1"
})));

const Icons = {
  Info: SvgInfoIcon,
  View: SvgView,
  StopView: SvgStopView,
  Delete: SvgDeleteIcon,
  Achievement: SvgAchievement,
  Award: SvgAward,
  Calendar: SvgCalendar,
  Chat: SvgChat,
  Checkbox: SvgCheckbox,
  Create: SvgCreate,
  Cross: SvgCross,
  Degree: SvgDegree,
  Download: SvgDownload,
  DropdownArrowBack: SvgDropdownArrowBack,
  DropdownArrowDown: SvgDropdownArrowDown,
  DropdownArrowUp: SvgDropdownArrowUp,
  DropdownCross: SvgDropdownCross,
  Edit: SvgEdit,
  Filter: SvgFilter,
  Lock: SvgLock,
  NavigationBack: SvgNavigationBack,
  NavigationBackBold: SvgNavigationBackBold,
  NavigationUp: SvgNavigationUp,
  NotificationError: SvgNotificationError,
  NotificationInfo: SvgNotificationInfo,
  NotificationSuccess: SvgNotificationSuccess,
  NotificationWarning: SvgNotificationWarning,
  Person: SvgPerson,
  Rocket: SvgRocket,
  Search: SvgSearch,
  Share: SvgShare,
  Skill: SvgSkill,
  Star: SvgStar,
  UploadCv: SvgUploadCvPictogram,
  ThreeDotsInHorizontalLine: SvgThreeDotsInHorizontalLine,
  CheckMark: SvgCheckMark
};

const classNames$i = require('classnames');
const TjTooltip = _ref => {
  let {
    disabled,
    place = 'top',
    event = 'click',
    message,
    title
  } = _ref;
  const rootElement = useRef(null);
  const [showMessage, setShowMessage] = useState(false);
  const handleOutsideClick = useCallback(e => {
    if (!(rootElement.current && rootElement.current.contains(e.target))) {
      setShowMessage(false);
    }
  }, []);
  useEffect(() => {
    if (event === 'click') {
      document.addEventListener('mousedown', handleOutsideClick);
      return () => document.removeEventListener('mousedown', handleOutsideClick);
    }
  }, []);
  const handleClick = useCallback(e => {
    e.preventDefault();
    e.stopPropagation();
    setShowMessage(!showMessage);
  }, [showMessage]);
  const containerClasses = classNames$i({
    'tj-tooltip-container': true,
    disabled: !!disabled,
    'tj-tooltip-hover-event': event === 'hover',
    ["tj-tooltip-message-placeholder-".concat(place)]: true,
    'tj-tooltip-state-default': !showMessage,
    'tj-tooltip-state-active': showMessage
  });
  return /*#__PURE__*/React__default.createElement("div", {
    ref: rootElement,
    role: "button",
    tabIndex: 0,
    onClick: event === 'click' ? handleClick : undefined,
    onKeyPress: e => e.key === 'Enter' ? handleClick(e) : null,
    className: containerClasses,
    "aria-label": message,
    "data-testid": "tj-tooltip-container"
  }, title ? title : /*#__PURE__*/React__default.createElement("div", {
    className: "tj-tooltip-icon-wrapper",
    "data-testid": "tj-tooltip-icon-wrapper"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "icon"
  }, /*#__PURE__*/React__default.createElement(Icons.Info, null))), showMessage || event === 'hover' ? /*#__PURE__*/React__default.createElement(TooltipMessage, {
    message: message,
    place: place
  }) : null);
};
TjTooltip.propTypes = toolTipPropTypes;

const labelPropTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  tooltipPosition: toolTipPropTypes.place,
  tooltipMessage: toolTipPropTypes.message
};

const Label = _ref => {
  let {
    label = '',
    required = false,
    disabled = false,
    tooltipMessage,
    tooltipPosition,
    ...props
  } = _ref;
  return /*#__PURE__*/React__default.createElement("label", _extends$A({
    className: "form-label tj-form-label ".concat(disabled ? 'disabled' : '')
  }, props), label, required && /*#__PURE__*/React__default.createElement("span", {
    "data-testid": "required-label",
    className: "tj-mandatory-icon"
  }, "*"), tooltipMessage && /*#__PURE__*/React__default.createElement(TjTooltip, {
    message: tooltipMessage,
    place: tooltipPosition
  }));
};
Label.propTypes = {
  ...labelPropTypes,
  label: labelPropTypes.label.isRequired
};

const classNames$h = require('classnames');
const BasicTextInput = (_ref, ref) => {
  let {
    error,
    touched,
    hint,
    label,
    tooltipPosition,
    disabled,
    tooltipMessage,
    required,
    prependIcon,
    ...restProps
  } = _ref;
  const PrependIcon = prependIcon ? Icons[prependIcon] : null;
  const id = restProps.id || restProps.name;
  const rawSearchInputClass = classNames$h({
    'input-group': true,
    'tj-input-group': true,
    'tj-prepend-input-group': !!PrependIcon
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: "form-group",
    "data-testid": "test-input"
  }, label && /*#__PURE__*/React__default.createElement(Label, {
    className: "tj-form-label mb8",
    tooltipPosition: tooltipPosition,
    label: label,
    htmlFor: id,
    required: required,
    disabled: disabled,
    tooltipMessage: tooltipMessage
  }), /*#__PURE__*/React__default.createElement("div", {
    className: rawSearchInputClass
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "position-relative w-100"
  }, PrependIcon && /*#__PURE__*/React__default.createElement("div", {
    className: "tj-input-group-addon-prepend"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "icon-wrapper",
    "data-testid": "test-prepend-icon"
  }, /*#__PURE__*/React__default.createElement(PrependIcon, null))), /*#__PURE__*/React__default.createElement(RawTextInput$1, _extends$A({}, restProps, {
    disabled: disabled,
    ref: ref,
    id: id,
    error: error,
    className: error ? 'is-invalid' : touched ? 'is-valid' : '',
    required: required
  }))), error && /*#__PURE__*/React__default.createElement(FeedbackMessage, {
    feedbackMessage: error,
    id: "".concat(id, "-hint")
  }), !error && hint && /*#__PURE__*/React__default.createElement(FeedbackMessage, {
    feedbackMessage: hint,
    id: "".concat(id, "-hint"),
    error: false
  })));
};
var BasicTextInput$1 = /*#__PURE__*/React__default.forwardRef(BasicTextInput);
BasicTextInput.propTypes = {
  error: PropTypes.string,
  label: labelPropTypes.label,
  required: PropTypes.bool,
  touched: PropTypes.bool,
  hint: PropTypes.string,
  tooltipPosition: toolTipPropTypes.place,
  tooltipMessage: toolTipPropTypes.message,
  disabled: PropTypes.bool,
  prependIcon: PropTypes.string
};

// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}

const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var native = {
  randomUUID
};

function v4(options, buf, offset) {
  if (native.randomUUID && !buf && !options) {
    return native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return unsafeStringify(rnds);
}

/**
 *
 * @param props
 * @param input
 * @returns {*&{onBlur: onBlur, onChange: onChange, onFocus: onFocus}}
 */
function mergeSomeEvent(props, input) {
  return {
    ...input,
    ...props,
    onChange: event => {
      if (typeof input.onChange === 'function') {
        input.onChange(event);
      }
      if (typeof props.onChange === 'function') {
        props.onChange(event);
      }
    },
    onBlur: event => {
      if (typeof input.onBlur === 'function') {
        input.onBlur(event);
      }
      if (typeof props.onBlur === 'function') {
        props.onBlur(event);
      }
    },
    onFocus: event => {
      // to merge the focus event
      if (typeof input.onFocus === 'function') {
        input.onFocus(event);
      }
      if (typeof props.onFocus === 'function') {
        props.onFocus(event);
      }
    }
  };
}
const validateFormValues = schema => async values => {
  try {
    await schema.validate(values, {
      abortEarly: false
    });
  } catch (err) {
    var _err$inner;
    const errors = (_err$inner = err.inner) === null || _err$inner === void 0 ? void 0 : _err$inner.reduce((formError, innerError) => {
      return setIn(formError, innerError.path, innerError.message);
    }, {});
    return errors;
  }
};
const numberFormat = number => {
  return typeof number === 'number' ? new Intl.NumberFormat().format(number) : null;
};
const defaultGetOptionLabelFnc = item => {
  return typeof item === 'object' ? item.label : item;
};
const defaultGetOptionValueFnc = item => {
  return typeof item === 'object' ? item.value : item;
};
function getNormalizeValueInArrayFormat(value, valueFnc) {
  if (!value) {
    return [];
  }
  return (typeof value === 'object' && value.constructor.name === 'Array' ? value : [value]).map(item => valueFnc(item));
}
const getElementOffset = el => {
  const rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return {
    top: rect.top + scrollTop,
    left: rect.left + scrollLeft
  };
};

/**
 * To check the given object constructor is array or not
 *
 * @param {object} value
 *
 * @returns boolean
 */
const isArray = value => {
  return !!value && typeof value === 'object' && value.constructor === Array;
};
function guidGenerator() {
  return v4();
}
const toBase64 = function (file) {
  let trimBase64 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64 = reader.result;
      if (!trimBase64) {
        resolve(base64);
        return;
      }
      const base64Array = base64.split('base64,');
      resolve(base64Array[1]);
    };
    reader.onerror = error => reject(error);
  });
};
const uploadFileToS3 = (preSignedS3Url, file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsArrayBuffer(file);
  reader.onload = () => {
    const arrayBuffer = reader.result;
    axios.put(preSignedS3Url, arrayBuffer, {
      maxBodyLength: 60000000
    }).then(_ref => {
      let {
        data
      } = _ref;
      return resolve(data);
    }).catch(error => resolve(error));
  };
  reader.onerror = error => reject(error);
});

/**
 * This function make the out before showing in input, Which expect to show in input after paste the copied data.
 *
 * @param {string} value
 * @param {string} newlyValue
 * @param {number} selectionStart
 * @param {number} selectionEnd
 *
 * @returns string
 */
function expectedValue(value, newlyValue, selectionStart, selectionEnd) {
  const startValue = value.toString().slice(0, selectionStart);
  const endValue = value.toString().slice(selectionEnd);
  return startValue + newlyValue.toString() + endValue;
}
const Timer = function (callback, delay) {
  var timerId,
    start,
    remaining = delay;
  this.pause = function () {
    window.clearTimeout(timerId);
    remaining -= Date.now() - start;
  };
  this.resume = function () {
    start = Date.now();
    window.clearTimeout(timerId);
    timerId = window.setTimeout(callback, remaining);
  };
  this.destroy = function () {
    if (timerId) {
      window.clearTimeout(timerId);
    }
  };
  this.resume();
};
const apiMessageTransform = (translateFnc, message) => {
  const messages = message ? message.toString().split(' ') : [];
  return messages.map(m => translateFnc(m)).join(' ');
};
function zeroPad(num, places) {
  const zero = places - num.toString().length + 1;
  return Array(+(zero > 0 && zero)).join('0') + num;
}
function makeValueArray(value) {
  return !isEmpty$1(value) && !isArray(value) ? [value] : !isEmpty$1(value) ? value : null;
}
function chunkSubstr(str, size) {
  const numChunks = Math.ceil(str.length / size);
  const chunks = new Array(numChunks);
  for (let i = 0, o = 0; i < numChunks; ++i, o += size) {
    chunks[i] = str.substr(o, size);
  }
  return chunks;
}
function reverseString(str) {
  const splitString = str.split('');
  const reverseArray = splitString.reverse();
  const joinArray = reverseArray.join('');
  return joinArray;
}
function breakWord(str) {
  const strArray = str.split(' ');
  return strArray.map(_str => chunkSubstr(reverseString(_str), 3).map(v => reverseString(v)).reverse());
}

const TjTextInput = _ref => {
  let {
    name,
    label,
    required,
    validate,
    ...restProps
  } = _ref;
  const {
    input,
    meta: {
      error,
      touched,
      submitError
    }
  } = useField(name, {
    validate
  });
  return /*#__PURE__*/React__default.createElement(BasicTextInput$1, _extends$A({
    label: label,
    required: required,
    name: name,
    touched: touched,
    error: touched && (error || submitError) ? error || submitError : null
  }, mergeSomeEvent(restProps, input)));
};
TjTextInput.propTypes = {
  name: PropTypes.string,
  validate: PropTypes.func,
  label: labelPropTypes.label,
  required: PropTypes.bool
};

const RawTextArea = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
    placeholder,
    className,
    required,
    ...restProps
  } = _ref;
  return /*#__PURE__*/React__default.createElement("textarea", _extends$A({}, restProps, {
    ref: ref,
    "aria-invalid": restProps.error ? true : false,
    "data-testid": "raw-text-area",
    id: restProps.id,
    "aria-describedby": "".concat(restProps.id, "-hint"),
    className: "form-control ".concat(className ? className : ''),
    placeholder: placeholder,
    "aria-required": required
  }));
});
RawTextArea.displayName = 'RawTextArea';
RawTextArea.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool
};

const classNames$g = require('classnames');
const BasicTextArea = _ref => {
  let {
    error,
    touched,
    label,
    hint,
    autoHeight = true,
    tooltipMessage,
    tooltipPosition = 'top',
    required,
    showCount = true,
    maxLength,
    disabled,
    ...restProps
  } = _ref;
  const ref = useRef();
  const [noOfChar, setChar] = useState(0);
  const [isActive, setActive] = useState(false);
  const id = restProps.id || restProps.name;
  const rawTextAreaClass = classNames$g({
    'is-invalid': !!error,
    'is-valid': !error && touched
  });
  const rootElementClass = classNames$g({
    'form-group': true,
    'tj-form-group': true,
    'is-active': isActive,
    'tj-form-text-area-group': true,
    'very-close-to-max-char': maxLength && maxLength - noOfChar <= 20,
    'is-counter': showCount,
    'is-disabled': disabled
  });
  useEffect(() => {
    if (autoHeight) {
      autoSize({
        target: ref.current
      });
    }
    if (ref.current) {
      setChar(ref.current.value ? ref.current.value.length : 0);
    }
  }, [ref]);
  const handleChange = e => {
    const val = e.target.value;
    setChar(val ? val.length : 0);
    if (autoHeight) {
      autoSize(e);
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: rootElementClass,
    "data-testid": "text-area-root-container"
  }, label && /*#__PURE__*/React__default.createElement(Label, {
    className: "tj-form-label mb8",
    tooltipPosition: tooltipPosition,
    label: label,
    htmlFor: id,
    required: required,
    disabled: disabled,
    tooltipMessage: tooltipMessage
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "input-group tj-input-group d-block tj-text-area-group"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "tj-text-area-container"
  }, /*#__PURE__*/React__default.createElement(RawTextArea, _extends$A({}, mergeSomeEvent(restProps, {
    onChange: handleChange,
    onBlur: () => setActive(false),
    onFocus: () => setActive(true)
  }), {
    ref: ref,
    error: error,
    id: id,
    maxLength: maxLength,
    disabled: disabled,
    className: rawTextAreaClass,
    required: required
  })), showCount && /*#__PURE__*/React__default.createElement("span", {
    className: "text-area-char-counter"
  }, numberFormat(noOfChar), maxLength ? "/".concat(numberFormat(maxLength)) : null)), error && /*#__PURE__*/React__default.createElement(FeedbackMessage, {
    feedbackMessage: error,
    id: "".concat(id, "-hint")
  }), !error && hint && /*#__PURE__*/React__default.createElement(FeedbackMessage, {
    feedbackMessage: hint,
    error: false,
    id: "".concat(id, "-hint")
  })));
};
BasicTextArea.propTypes = {
  error: PropTypes.string,
  label: labelPropTypes.label,
  required: PropTypes.bool,
  touched: PropTypes.bool,
  hint: PropTypes.string,
  tooltipPosition: toolTipPropTypes.place,
  tooltipMessage: toolTipPropTypes.message,
  maxLength: PropTypes.number,
  showCount: PropTypes.bool,
  autoHeight: PropTypes.bool,
  disabled: PropTypes.bool
};
const autoSize = e => {
  const el = e.target;
  setTimeout(function () {
    autoExpand(el);
  }, 0);
};
const autoExpand = function (field) {
  // Reset field height
  field.style.height = 'inherit';
  field.style.overflow = 'hidden';

  // Get the computed styles for the element
  const computed = window.getComputedStyle(field);
  const paddingHeight = parseInt(computed.getPropertyValue('padding-top'), 10) + parseInt(computed.getPropertyValue('padding-bottom'), 10);

  // Calculate the height
  let height = parseInt(computed.getPropertyValue('border-top-width'), 10) + field.scrollHeight + paddingHeight + parseInt(computed.getPropertyValue('border-bottom-width'), 10);
  if (height > 356) {
    height = 356;
    field.style.overflow = 'auto';
  }
  const _value = field.value || '';
  if (field.selectionStart === _value.length) {
    field.scrollTop = field.scrollHeight;
  }
  field.style.height = height - paddingHeight + 'px';
};

const TjTextArea = _ref => {
  let {
    name,
    label,
    validate,
    required,
    ...restProps
  } = _ref;
  const {
    input,
    meta: {
      error,
      touched,
      submitError
    }
  } = useField(name, {
    validate
  });
  return /*#__PURE__*/React__default.createElement(BasicTextArea, _extends$A({
    label: label,
    required: required,
    name: name,
    touched: touched,
    error: touched && (error || submitError) ? error || submitError : null
  }, mergeSomeEvent(restProps, input)));
};
TjTextArea.propTypes = {
  name: PropTypes.string.isRequired,
  label: labelPropTypes.label,
  required: PropTypes.bool,
  validate: PropTypes.func
};

const RawPasswordInput = _ref => {
  let {
    type = 'password',
    dataTestid = 'raw-password-input',
    ...restProps
  } = _ref;
  return /*#__PURE__*/React__default.createElement(RawTextInput$1, _extends$A({}, restProps, {
    type: type,
    "data-testid": dataTestid
  }));
};
RawPasswordInput.propTypes = {
  type: PropTypes.oneOf(['text', 'password']),
  dataTestid: PropTypes.string
};

const classNames$f = require('classnames');
const BasicPasswordInput = _ref => {
  let {
    error,
    touched,
    label,
    hint,
    tooltipMessage,
    tooltipPosition = 'top',
    required,
    maxLength,
    minLength,
    disabled,
    ...restProps
  } = _ref;
  const [type, setType] = useState('password');
  const [isActive, setActive] = useState(false);
  const id = restProps.id || restProps.name;
  const rawPasswordInputClass = classNames$f({
    'is-invalid': !!error,
    'is-valid': !error && touched
  });
  const rootElementClass = classNames$f({
    'form-group': true,
    'is-active': isActive,
    'tj-form-group': true,
    'tj-form-password-input-group': true,
    'is-disabled': disabled
  });
  const handleEyeIconClick = useCallback(() => {
    setType(type === 'password' ? 'text' : 'password');
  }, [type]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: rootElementClass,
    "data-testid": "password-input-root-container"
  }, label && /*#__PURE__*/React__default.createElement(Label, {
    className: "tj-form-label mb8",
    tooltipPosition: tooltipPosition,
    label: label,
    htmlFor: id,
    required: required,
    disabled: disabled,
    tooltipMessage: tooltipMessage
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "input-group tj-input-group"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "position-relative w-100"
  }, /*#__PURE__*/React__default.createElement(RawPasswordInput, _extends$A({}, mergeSomeEvent(restProps, {
    onBlur: () => setActive(false),
    onFocus: () => setActive(true)
  }), {
    className: rawPasswordInputClass,
    maxLength: maxLength,
    minLength: minLength,
    type: type,
    id: id,
    disabled: disabled,
    required: required
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "tj-input-group-addon-append"
  }, /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    disabled: disabled,
    "data-testid": "tj-password-eye-icon",
    onClick: handleEyeIconClick,
    className: "btn btn-link tj-password-eye-btn highlight-on-hover"
  }, type === 'password' ? /*#__PURE__*/React__default.createElement(Icons.View, null) : /*#__PURE__*/React__default.createElement(Icons.StopView, null)))), error && /*#__PURE__*/React__default.createElement(FeedbackMessage, {
    feedbackMessage: error
  }), !error && hint && /*#__PURE__*/React__default.createElement(FeedbackMessage, {
    feedbackMessage: hint,
    error: false
  })));
};
BasicPasswordInput.propTypes = {
  error: PropTypes.string,
  label: labelPropTypes.label,
  required: PropTypes.bool,
  touched: PropTypes.bool,
  hint: PropTypes.string,
  tooltipPosition: toolTipPropTypes.place,
  tooltipMessage: toolTipPropTypes.message,
  maxLength: PropTypes.number,
  minLength: PropTypes.number,
  disabled: PropTypes.bool
};

const TjPasswordInput = _ref => {
  let {
    name,
    label,
    validate,
    required,
    ...restProps
  } = _ref;
  const {
    input,
    meta: {
      error,
      touched,
      submitError
    }
  } = useField(name, {
    validate
  });
  return /*#__PURE__*/React__default.createElement(BasicPasswordInput, _extends$A({
    label: label,
    required: required,
    name: name,
    touched: touched,
    error: touched && (error || submitError) ? error || submitError : null
  }, mergeSomeEvent(restProps, input)));
};
TjPasswordInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: labelPropTypes.label,
  required: PropTypes.bool,
  validate: PropTypes.func
};

const setOnClick = (e, stopPropagation, onClick) => {
  if (stopPropagation) {
    e.stopPropagation();
  }
  if (typeof onClick === 'function') {
    onClick(e);
  }
};

/* Base button component */
const BaseButton = _ref => {
  let {
    variant = 'primary',
    children,
    disabled,
    onClick,
    stopPropagation = true,
    type,
    ...props
  } = _ref;
  return /*#__PURE__*/React__default.createElement("button", _extends$A({
    type: type,
    disabled: disabled,
    onClick: e => setOnClick(e, stopPropagation, onClick),
    className: "button tj-button-".concat(variant, " tj-button-").concat(variant, "-font-color")
  }, props), children);
};
BaseButton.propTypes = {
  variant: PropTypes.oneOf(['primary', 'secondary']),
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  stopPropagation: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'reset', 'submit']),
  icon: PropTypes.string
};

/* Button component with icon */
const ButtonWithIcon = _ref2 => {
  let {
    children,
    variant,
    ...props
  } = _ref2;
  return /*#__PURE__*/React__default.createElement(BaseButton, _extends$A({}, props, {
    className: "button circular-button tj-button-".concat(variant)
  }), children);
};
ButtonWithIcon.propTypes = {
  variant: PropTypes.oneOf(['primary', 'secondary']),
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};

/* Main button component */
const TjButton = _ref3 => {
  let {
    icon,
    ...props
  } = _ref3;
  return icon ? /*#__PURE__*/React__default.createElement(ButtonWithIcon, _extends$A({
    "data-testid": "icon-button",
    icon: icon
  }, props)) : /*#__PURE__*/React__default.createElement(BaseButton, _extends$A({
    "data-testid": "base-button"
  }, props));
};
TjButton.propTypes = {
  icon: PropTypes.string
};

const RawRadioButton = _ref => {
  let {
    checked,
    ...props
  } = _ref;
  return /*#__PURE__*/React__default.createElement(RawTextInput$1, _extends$A({}, props, {
    type: "radio",
    tabIndex: 0,
    checked: checked,
    "aria-checked": checked ? 'true' : 'false',
    noDefaultClass: true
  }));
};
RawRadioButton.propTypes = {
  checked: PropTypes.bool
};

const classNames$e = require('classnames');
const BasicRadioButton = _ref => {
  let {
    required,
    name,
    disabled,
    id,
    label,
    error,
    touched,
    ariaRequired,
    ...restProps
  } = _ref;
  const uniqueId = id ? id : name;
  const rawRadioClass = classNames$e({
    'is-invalid': !!error,
    'is-valid': !error && touched,
    'form-check-input': true,
    'radio-button': true,
    'tj-radio-button': true
  });
  const labelClass = classNames$e({
    'form-check-label': true,
    'tj-radio-checkbox-label': true,
    disabled
  });
  const radioButtonWrapperClass = classNames$e({
    'form-check': true,
    item: true,
    mb8: true
  });
  const customRadioButtonClass = classNames$e({
    'circle-button': true,
    disabled,
    active: !disabled
  });
  return /*#__PURE__*/React__default.createElement("label", {
    htmlFor: uniqueId,
    className: radioButtonWrapperClass
  }, /*#__PURE__*/React__default.createElement(RawRadioButton, _extends$A({
    name: name
  }, restProps, {
    className: rawRadioClass,
    disabled: disabled,
    id: uniqueId,
    required: required || ariaRequired
  })), /*#__PURE__*/React__default.createElement("span", {
    className: customRadioButtonClass
  }), label && /*#__PURE__*/React__default.createElement(Label, {
    htmlFor: uniqueId,
    label: label,
    disabled: disabled,
    required: required,
    className: labelClass
  }));
};
BasicRadioButton.propTypes = {
  name: PropTypes.string.isRequired,
  label: labelPropTypes.label,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  ariaRequired: PropTypes.bool,
  id: PropTypes.string,
  error: PropTypes.string,
  touched: PropTypes.bool
};

const TjRadioButton = _ref => {
  let {
    name,
    label,
    validate,
    required,
    value,
    ...restProps
  } = _ref;
  const {
    input,
    meta: {
      error,
      touched,
      submitError
    }
  } = useField(name, {
    type: 'radio',
    value,
    multiple: false,
    validate
  });
  return /*#__PURE__*/React__default.createElement(BasicRadioButton, _extends$A({
    label: label,
    required: required,
    name: name,
    error: touched && (error || submitError) ? error || submitError : null,
    touched: touched
  }, mergeSomeEvent(restProps, input)));
};
TjRadioButton.propTypes = {
  name: PropTypes.string.isRequired,
  label: labelPropTypes.label,
  required: PropTypes.bool,
  value: PropTypes.string,
  validate: PropTypes.func
};

const RawCheckbox = _ref => {
  let {
    checked,
    dataTestid = 'raw-checkbox',
    ...props
  } = _ref;
  return /*#__PURE__*/React__default.createElement(RawTextInput$1, _extends$A({}, props, {
    "data-testid": dataTestid,
    tabIndex: 0,
    checked: checked,
    "aria-checked": checked ? 'true' : 'false',
    type: "checkbox"
  }));
};
RawCheckbox.propTypes = {
  dataTestid: PropTypes.string,
  checked: PropTypes.bool
};

const classNames$d = require('classnames');
const BasicCheckbox = _ref => {
  let {
    required,
    name,
    disabled,
    id,
    label,
    ariaRequired,
    noTabIndex,
    ...restProps
  } = _ref;
  const uniqueId = id ? id : name;
  const labelClass = classNames$d({
    'form-check-label': true,
    'tj-radio-checkbox-label': true,
    disabled
  });
  const radioButtonWrapperClass = classNames$d({
    disabled,
    'form-check': true,
    'tj-checkbox': true,
    active: !disabled,
    mb8: true
  });
  return /*#__PURE__*/React__default.createElement("label", {
    htmlFor: uniqueId,
    className: radioButtonWrapperClass
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "checkbox-conatiner"
  }, /*#__PURE__*/React__default.createElement(RawCheckbox, _extends$A({
    id: uniqueId,
    name: name,
    disabled: disabled,
    "data-testid": "checkbox",
    tabIndex: noTabIndex ? -1 : 0,
    required: required || ariaRequired
  }, restProps))), /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "click-event"
  }), label && /*#__PURE__*/React__default.createElement(Label, {
    htmlFor: uniqueId,
    label: label,
    disabled: disabled,
    required: required,
    className: labelClass
  }));
};
BasicCheckbox.propTypes = {
  name: PropTypes.string,
  id: PropTypes.string,
  label: labelPropTypes.label,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  ariaRequired: PropTypes.bool,
  noTabIndex: PropTypes.bool
};

const TjCheckbox = _ref => {
  let {
    name,
    label,
    required,
    value,
    validate,
    ...restProps
  } = _ref;
  const {
    input
  } = useField(name, {
    type: 'checkbox',
    value,
    validate,
    multiple: false
  });
  return /*#__PURE__*/React__default.createElement(BasicCheckbox, _extends$A({
    label: label,
    required: required,
    name: name
  }, mergeSomeEvent(restProps, input)));
};
TjCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
  label: labelPropTypes.label,
  required: PropTypes.bool,
  value: PropTypes.string,
  validate: PropTypes.func
};

const TjError = _ref => {
  let {
    name
  } = _ref;
  const {
    touched: allTouchedFields,
    errors,
    submitErrors
  } = useFormState();
  const error = getIn(errors, name);
  const touched = allTouchedFields === null || allTouchedFields === void 0 ? void 0 : allTouchedFields[name];
  const submitError = getIn(submitErrors, name);
  const _error = touched && (error || submitError) ? error || submitError : null;
  return _error ? /*#__PURE__*/React__default.createElement(FeedbackMessage, {
    feedbackMessage: _error
  }) : null;
};
TjError.propTypes = {
  name: PropTypes.string
};

const dropDownItemProp = PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
})]);
const dropDownPropTypes = {
  value: PropTypes.oneOfType([dropDownItemProp, PropTypes.arrayOf(dropDownItemProp)]),
  item: dropDownItemProp,
  getOptionLabel: PropTypes.func,
  getOptionValue: PropTypes.func,
  isSelected: PropTypes.bool,
  options: PropTypes.arrayOf(dropDownItemProp),
  minHeight: PropTypes.number,
  disabled: PropTypes.bool,
  isSearchable: PropTypes.bool,
  isOptionDisabled: PropTypes.func,
  multiple: PropTypes.bool,
  placeholder: PropTypes.string,
  normalizeValue: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  name: PropTypes.string,
  moreThanOneLabel: PropTypes.string,
  closeOnClick: PropTypes.bool,
  showCheckbox: PropTypes.bool
};

const classNames$c = require('classnames');
const TjDropDownItem = _ref => {
  let {
    label,
    isSelected,
    disabled,
    id,
    showCheckbox,
    ...restProps
  } = _ref;
  const wrapperClass = classNames$c({
    'tj-drop-down-item-wrapper': true,
    selected: isSelected,
    disabled,
    'list-checkbox': showCheckbox
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: wrapperClass
  }, /*#__PURE__*/React__default.createElement("button", _extends$A({
    disabled: disabled,
    "data-testid": "tj-drop-down-list-item-".concat(typeof label === 'string' ? label : id),
    className: "btn btn-link item-button"
  }, restProps, {
    type: "button",
    tabIndex: -1
  }), label, showCheckbox ? /*#__PURE__*/React__default.createElement(BasicCheckbox, {
    checked: isSelected,
    onChange: () => {},
    noTabIndex: true
  }) : null));
};
TjDropDownItem.propTypes = {
  value: dropDownPropTypes.value,
  label: labelPropTypes.label,
  id: dropDownPropTypes.name,
  isSelected: dropDownPropTypes.isSelected,
  disabled: dropDownPropTypes.disabled,
  showCheckbox: dropDownPropTypes.showCheckbox
};

const TjDropDownList = _ref => {
  let {
    options,
    value,
    getOptionLabel,
    getOptionValue,
    isOptionDisabled,
    normalizeValue,
    onClick,
    showCheckbox,
    minHeight = 309,
    name,
    closeOptions = () => {},
    notFoundLabel,
    onClickNotFoundLabel
  } = _ref;
  const valueFnc = useCallback(typeof getOptionValue === 'function' ? getOptionValue : defaultGetOptionValueFnc, [getOptionValue]);
  const labelFnc = useCallback(typeof getOptionLabel === 'function' ? getOptionLabel : defaultGetOptionLabelFnc, [getOptionLabel]);
  const _normalizeValue = useMemo(function () {
    return normalizeValue ? normalizeValue : getNormalizeValueInArrayFormat(value, valueFnc);
  }, [value, valueFnc, normalizeValue]);
  const handleChange = useCallback(function (itemNormalizeValue) {
    return event => {
      event.stopPropagation();
      onClick(itemNormalizeValue);
    };
  }, [onClick]);
  const handleKeyDown = (event, itemNormalizeValue, index) => {
    const elementList = document.getElementById("space-wrapper-".concat(name)).querySelectorAll('[role="option"]');
    switch (event.key) {
      case 'ArrowUp':
        event.preventDefault();
        event.stopPropagation();
        if (index === 0) return;
        elementList[index - 1].focus();
        break;
      case 'ArrowDown':
        event.preventDefault();
        event.stopPropagation();
        if (index + 1 === elementList.length) return;
        elementList[index + 1].focus();
        break;
      case ' ':
      case 'SpaceBar':
      case 'Enter':
        event.preventDefault();
        event.stopPropagation();
        onClick(itemNormalizeValue);
        break;
      case 'Escape':
        event.preventDefault();
        closeOptions();
        break;
      case 'Tab':
        closeOptions();
        break;
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "tj-drop-down-list-wrapper",
    "data-testid": "tj-drop-down-list-wrapper",
    style: {
      maxHeight: "".concat(minHeight, "px")
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "space-wrapper",
    role: "listbox",
    tabIndex: -1,
    onKeyDown: handleKeyDown,
    id: "space-wrapper-".concat(name)
  }, options.map((item, index) => {
    const itemNormalizeValue = valueFnc(item);
    const disabled = typeof isOptionDisabled === 'function' ? isOptionDisabled(item) : false;
    const isSelected = _normalizeValue.some(val => val === itemNormalizeValue);
    return /*#__PURE__*/React__default.createElement(TjDropDownItem, {
      isSelected: isSelected,
      key: itemNormalizeValue.toString(),
      id: itemNormalizeValue.toString(),
      label: labelFnc(item),
      onClick: handleChange(itemNormalizeValue),
      onKeyDown: e => handleKeyDown(e, itemNormalizeValue, index),
      disabled: disabled,
      showCheckbox: showCheckbox,
      role: "option",
      "aria-selected": isSelected
    });
  }), !options.length && notFoundLabel ? /*#__PURE__*/React__default.createElement(TjDropDownItem, {
    isSelected: false,
    label: notFoundLabel,
    onClick: onClickNotFoundLabel,
    role: "option",
    id: "notfound",
    "aria-selected": false
  }) : null));
};
TjDropDownList.propTypes = {
  options: dropDownPropTypes.options.isRequired,
  value: dropDownPropTypes.value,
  getOptionLabel: dropDownPropTypes.getOptionLabel,
  getOptionValue: dropDownPropTypes.getOptionValue,
  minHeight: dropDownPropTypes.minHeight,
  isOptionDisabled: dropDownPropTypes.isOptionDisabled,
  normalizeValue: dropDownPropTypes.normalizeValue,
  showCheckbox: dropDownPropTypes.showCheckbox,
  onClick: PropTypes.func,
  name: PropTypes.string.isRequired,
  closeOptions: PropTypes.func,
  onClickNotFoundLabel: PropTypes.func,
  notFoundLabel: labelPropTypes.label
};

/* eslint-disable no-case-declarations */
const classNames$b = require('classnames');
const RawSelect = _ref => {
  let {
    name,
    value,
    multiple,
    options,
    getOptionLabel,
    getOptionValue,
    minHeight,
    isOptionDisabled,
    isSearchable = true,
    disabled,
    placeholder,
    onChange,
    closeOnClick = true,
    moreThanOneLabel = 'and Other',
    className,
    showPlaceholderInList = false,
    idForLabel,
    required,
    searchInKeys = ['name', 'email', 'label', 'value'],
    notFoundLabel,
    onClickNotFoundLabel,
    customSelectedLabel
  } = _ref;
  const [searchText, setSearchText] = useState('');
  const [isSearchFocus, setSearchFocusStatus] = useState();
  const _options = placeholder && showPlaceholderInList ? [{
    label: placeholder,
    value: ''
  }, ...options] : options;
  const rootElement = useRef(null);
  const [isOpen, setOpen] = useState(false);
  const [openPosition, setOpenPosition] = useState('');
  const wrapperClass = classNames$b({
    'tj-raw-selector-wrapper': true,
    'is-open': isOpen,
    [className]: !!className,
    ["list-open-position-".concat(openPosition)]: true,
    disabled,
    multiple
  });
  const searchTextClass = classNames$b({
    searchDropdown: true,
    disabled,
    disableSearchDropdown: disabled
  });
  useEffect(() => {
    var _rootElement$current, _rootElement$current2;
    const bottomSheetContent = rootElement === null || rootElement === void 0 || (_rootElement$current = rootElement.current) === null || _rootElement$current === void 0 ? void 0 : _rootElement$current.closest('.tj-bottom-sheet-content');
    const bottomSheetBody = rootElement === null || rootElement === void 0 || (_rootElement$current2 = rootElement.current) === null || _rootElement$current2 === void 0 ? void 0 : _rootElement$current2.closest('.tj-bottom-sheet-body');
    if (bottomSheetContent) {
      bottomSheetContent.style.overflow = isOpen ? 'initial' : 'hidden';
      bottomSheetBody.style.overflowY = isOpen ? 'initial' : 'auto';
    }
  }, [isOpen]);
  const valueFnc = useCallback(typeof getOptionValue === 'function' ? getOptionValue : defaultGetOptionValueFnc, [getOptionValue]);
  const labelFnc = useCallback(typeof getOptionLabel === 'function' ? getOptionLabel : defaultGetOptionLabelFnc, [getOptionLabel]);
  const normalizeValue = useMemo(function () {
    return getNormalizeValueInArrayFormat(value, valueFnc);
  }, [value, valueFnc]);
  const normalizeLabel = useMemo(function () {
    return getNormalizeValueInArrayFormat(value, labelFnc);
  }, [value, labelFnc]);
  const closeOptions = () => {
    setOpen(false);
    setOpenPosition('');
    setSearchText('');
  };
  const handleClick = useCallback(function (event) {
    event.stopPropagation();
    if (disabled) {
      return false;
    }
    const element = rootElement.current.firstElementChild;
    if (isOpen) {
      closeOptions();
      return;
    }
    const selectorHeight = element.offsetHeight;
    const selectYPosition = getElementOffset(element).top;
    const windowHeight = document.documentElement.clientHeight;
    const windowScrollTop = document.documentElement.scrollTop;
    const availableHeightInTop = selectYPosition - windowScrollTop;
    const availableHeightInBottom = windowHeight - (availableHeightInTop + selectorHeight);
    const listElementContainer = element.nextElementSibling;
    const listElement = listElementContainer.firstElementChild;
    const listHeight = listElement.offsetHeight;
    listElement.style.height = 'auto';
    setOpen(true);
    let availableHeight = 0;
    if (listHeight > availableHeightInBottom && availableHeightInBottom <= availableHeightInTop) {
      setOpenPosition('top');
      availableHeight = availableHeightInTop - 5;
    } else {
      availableHeight = availableHeightInBottom - 5;
      setOpenPosition('bottom');
    }
    listElement.style.maxHeight = "".concat(availableHeight >= 309 ? 309 : availableHeight, "px");
  }, [isOpen, rootElement, disabled]);
  const handleOutsideClick = useCallback(e => {
    if (!(rootElement.current && rootElement.current.contains(e.target))) {
      setOpen(false);
      setOpenPosition('');
      setSearchText('');
    }
  }, []);
  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, []);
  const handleOnChange = itemNormalizeValue => {
    if (disabled) {
      return false;
    }
    const index = normalizeValue.indexOf(itemNormalizeValue);
    const newValues = multiple ? [...normalizeValue] : [];
    if (index !== -1) {
      newValues.splice(index, 1);
    } else {
      newValues.push(itemNormalizeValue);
    }
    const selectedOptions = options.filter(option => {
      const optionValue = valueFnc(option);
      return newValues.includes(optionValue);
    });
    if (typeof onChange === 'function') {
      onChange(multiple ? selectedOptions : selectedOptions.length ? selectedOptions[0] : null);
    }
    if (closeOnClick) {
      closeOptions();
    }
  };
  const handleListKeyDown = e => {
    var _document;
    switch (e.key) {
      case 'Escape':
        e.preventDefault();
        closeOptions();
        break;
      case ' ':
      case 'SpaceBar':
      case 'Enter':
        e.preventDefault();
        handleClick(e);
        break;
      case 'ArrowDown':
        e.preventDefault();
        if (!isOpen) break;
        (_document = document) === null || _document === void 0 || (_document = _document.getElementById("list-container-".concat(idForLabel))) === null || _document === void 0 || (_document = _document.querySelectorAll('[role="option"]')[0]) === null || _document === void 0 || _document.focus();
        break;
    }
  };
  const handleSearchChange = e => {
    setSearchText(e.target.value);
  };
  const handleSearchFocus = () => {
    setSearchFocusStatus(true);
  };
  const displayOptions = _options.filter(item => {
    if (searchText) {
      const _searchText = searchText.toString().toLowerCase();
      if (typeof item === 'object') {
        return searchInKeys.some(key => {
          const _propValue = get(item, key, '');
          const propValue = _propValue ? _propValue.toString().toLowerCase() : '';
          return propValue.includes(_searchText);
        });
      } else {
        const _item = item ? item.toString().toLowerCase() : '';
        return _item.includes(_searchText);
      }
    } else {
      return true;
    }
  });
  const handleSearchKeyDown = e => {
    e.stopPropagation();
    if (!isOpen) {
      handleClick(e);
    }
    if (e.key === 'ArrowDown' && isOpen) {
      var _document2;
      (_document2 = document) === null || _document2 === void 0 || (_document2 = _document2.getElementById("list-container-".concat(idForLabel))) === null || _document2 === void 0 || (_document2 = _document2.querySelectorAll('[role="option"]')[0]) === null || _document2 === void 0 || _document2.focus();
    }
  };
  const shouldLabelAppear = !isOpen && !isSearchFocus || !isSearchable;
  return /*#__PURE__*/React__default.createElement("div", {
    ref: rootElement,
    "data-testid": "tj-selector-wrapper",
    className: wrapperClass
  }, /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "tj-selector",
    className: "tj-selector",
    onClick: handleClick,
    onKeyDown: handleListKeyDown,
    tabIndex: 0,
    role: "combobox",
    "aria-controls": "list-container-".concat(name),
    "aria-haspopup": "listbox",
    "aria-expanded": isOpen,
    "aria-required": required,
    id: idForLabel
  }, placeholder && normalizeLabel && shouldLabelAppear && !normalizeValue.length ? /*#__PURE__*/React__default.createElement("div", {
    className: "placeholder"
  }, placeholder) : null, normalizeLabel && shouldLabelAppear && (!customSelectedLabel ? /*#__PURE__*/React__default.createElement("span", {
    className: "selected-label"
  }, normalizeLabel[normalizeLabel.length - 1], normalizeLabel.length > 1 ? " (".concat(moreThanOneLabel, ")") : null) : ( /*#__PURE__*/React__default.createElement(customSelectedLabel, {
    normalizeLabel,
    value
  }))), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    name: name,
    tabIndex: -1,
    "aria-hidden": "true"
  }), isSearchable ? /*#__PURE__*/React__default.createElement("input", {
    type: "text",
    className: searchTextClass,
    name: "searchDropdown",
    "data-testid": "tj-dropdownSearch",
    value: searchText,
    onChange: handleSearchChange,
    onFocus: handleSearchFocus,
    onKeyDown: handleSearchKeyDown,
    disabled: disabled,
    onBlur: () => {
      setSearchFocusStatus(false);
    }
  }) : null), /*#__PURE__*/React__default.createElement("div", {
    className: "select-dd-list-container",
    id: "list-container-".concat(name)
  }, /*#__PURE__*/React__default.createElement(TjDropDownList, {
    name: name,
    value: value,
    minHeight: minHeight,
    isOptionDisabled: isOptionDisabled,
    options: displayOptions,
    getOptionLabel: getOptionLabel,
    getOptionValue: getOptionValue,
    normalizeValue: normalizeValue,
    showCheckbox: multiple,
    onClick: handleOnChange,
    notFoundLabel: notFoundLabel,
    onClickNotFoundLabel: onClickNotFoundLabel,
    closeOptions: closeOptions
  })));
};
RawSelect.propTypes = {
  name: dropDownPropTypes.name.isRequired,
  value: dropDownPropTypes.value,
  multiple: dropDownPropTypes.multiple,
  options: dropDownPropTypes.options,
  getOptionLabel: dropDownPropTypes.getOptionLabel,
  getOptionValue: dropDownPropTypes.getOptionValue,
  minHeight: dropDownPropTypes.minHeight,
  isOptionDisabled: dropDownPropTypes.isOptionDisabled,
  placeholder: dropDownPropTypes.placeholder,
  disabled: dropDownPropTypes.disabled,
  isSearchable: dropDownPropTypes.isSearchable,
  moreThanOneLabel: dropDownPropTypes.moreThanOneLabel,
  onChange: PropTypes.func,
  className: PropTypes.string,
  closeOnClick: dropDownPropTypes.closeOnClick,
  showPlaceholderInList: PropTypes.bool,
  idForLabel: PropTypes.string,
  required: PropTypes.bool,
  searchInKeys: PropTypes.arrayOf(PropTypes.string),
  notFoundLabel: labelPropTypes.label,
  customSelectedLabel: PropTypes.elementType,
  onClickNotFoundLabel: PropTypes.func
};

const BasicSelect = _ref => {
  let {
    error,
    touched,
    hint,
    label,
    tooltipPosition,
    disabled,
    tooltipMessage,
    required,
    name,
    options,
    ...restProps
  } = _ref;
  const id = restProps.id || name;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "form-group",
    "data-testid": "test-select"
  }, label && /*#__PURE__*/React__default.createElement(Label, {
    className: "tj-form-label mb8",
    tooltipPosition: tooltipPosition,
    label: label,
    htmlFor: id,
    required: required,
    disabled: disabled,
    tooltipMessage: tooltipMessage
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "input-group tj-select-group"
  }, /*#__PURE__*/React__default.createElement(RawSelect, _extends$A({}, restProps, {
    name: name,
    disabled: disabled,
    options: options,
    className: error ? 'is-invalid' : touched ? 'is-valid' : '',
    idForLabel: id,
    required: required
  })), error && /*#__PURE__*/React__default.createElement(FeedbackMessage, {
    feedbackMessage: error
  }), !error && hint && /*#__PURE__*/React__default.createElement(FeedbackMessage, {
    feedbackMessage: hint,
    error: false
  })));
};
BasicSelect.propTypes = {
  error: PropTypes.string,
  label: labelPropTypes.label,
  required: PropTypes.bool,
  touched: PropTypes.bool,
  hint: PropTypes.string,
  tooltipPosition: toolTipPropTypes.place,
  tooltipMessage: toolTipPropTypes.message,
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  options: dropDownPropTypes.options.isRequired
};

const TjSelect = _ref => {
  let {
    name,
    label,
    required,
    moreThanOneLabel,
    validate,
    ...restProps
  } = _ref;
  const {
    input,
    meta: {
      error,
      touched,
      submitError
    }
  } = useField(name, {
    validate
  });
  return /*#__PURE__*/React__default.createElement(BasicSelect, _extends$A({
    label: label,
    required: required,
    name: name,
    moreThanOneLabel: moreThanOneLabel,
    touched: touched,
    error: touched && (error || submitError) ? error || submitError : null
  }, mergeSomeEvent(restProps, input)));
};
TjSelect.propTypes = {
  name: dropDownPropTypes.name.isRequired,
  label: labelPropTypes.label,
  required: PropTypes.bool,
  validate: PropTypes.func,
  moreThanOneLabel: dropDownPropTypes.moreThanOneLabel
};

const COLOR_REGEX = /^#[0-9a-f]{6}$/i;
const COLOR_EXPECTED_REGEX = /^#[0-9a-f]{0,6}$/i;
const RawColorPicker = _ref => {
  let {
    placeholder,
    id,
    name,
    className,
    dataTestid = 'raw-color-input',
    disabled,
    onBlur,
    onFocus,
    ...restProps
  } = _ref;
  const [value, setValue] = useState(restProps.value);
  const handleChange = e => {
    setValue(e.target.value);
  };
  useEffect(function () {
    if (restProps.value !== value) {
      setValue(restProps.value);
    }
  }, [restProps.value]);
  const handleInputChange = useCallback(function (e) {
    handleChange(e);
    if (typeof restProps.onChange === 'function') {
      restProps.onChange(e);
    }
  }, []);
  const uniqueId = id ? id : name;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "raw-color-input-wrapper"
  }, /*#__PURE__*/React__default.createElement(RawTextInput$1, _extends$A({}, mergeSomeEvent(restProps, {
    onChange: handleChange
  }), {
    value: value,
    type: "color",
    name: name,
    noDefaultClass: true,
    id: uniqueId,
    disabled: disabled,
    "data-testid": dataTestid
  })), /*#__PURE__*/React__default.createElement("input", {
    type: "text",
    value: value,
    onChange: handleInputChange,
    onClick: handleColorInputClick,
    onPaste: handleColorPaste,
    onKeyPress: handleColorKeyPress,
    placeholder: placeholder,
    "data-testid": "color-picker-input",
    maxLength: 7,
    minLength: 7,
    onBlur: onBlur,
    onFocus: onFocus,
    disabled: disabled,
    className: "form-control ".concat(className ? className : '')
  }));
};
RawColorPicker.propTypes = {
  dataTestid: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func
};
const handleColorPaste = function (e) {
  const {
    selectionEnd,
    value,
    selectionStart
  } = e.currentTarget;
  const copiedData = e.clipboardData.getData('Text');
  const _value = expectedValue(value, copiedData, selectionStart, selectionEnd);
  if (_value && !_value.toString().match(COLOR_REGEX)) {
    e.preventDefault();
  }
};
const handleColorInputClick = function (e) {
  e.target.setSelectionRange(0, e.target.value.length);
};
const handleColorKeyPress = function (e) {
  const {
    selectionEnd,
    value,
    selectionStart
  } = e.currentTarget;
  const _value = expectedValue(value, e.key, selectionStart, selectionEnd);
  if (!_value.toString().match(COLOR_EXPECTED_REGEX)) {
    e.preventDefault();
  }
};

const classNames$a = require('classnames');
const BasicColorPicker = _ref => {
  let {
    error,
    touched,
    hint,
    label,
    tooltipPosition,
    disabled,
    tooltipMessage,
    required,
    ...restProps
  } = _ref;
  const [isActive, setActive] = useState(false);
  const rootElementClass = classNames$a({
    'form-group': true,
    'is-active': isActive
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: rootElementClass,
    "data-testid": "test-input-color"
  }, label && /*#__PURE__*/React__default.createElement(Label, {
    className: "tj-form-label mb8",
    tooltipPosition: tooltipPosition,
    label: label,
    required: required,
    disabled: disabled,
    tooltipMessage: tooltipMessage
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "input-group tj-input-color-group"
  }, /*#__PURE__*/React__default.createElement(RawColorPicker, _extends$A({}, restProps, {
    onBlur: () => setActive(false),
    onFocus: () => setActive(true),
    disabled: disabled,
    className: error ? 'is-invalid' : touched ? 'is-valid' : ''
  })), error && /*#__PURE__*/React__default.createElement(FeedbackMessage, {
    feedbackMessage: error
  }), !error && hint && /*#__PURE__*/React__default.createElement(FeedbackMessage, {
    feedbackMessage: hint,
    error: false
  })));
};
BasicColorPicker.propTypes = {
  error: PropTypes.string,
  label: labelPropTypes.label,
  required: PropTypes.bool,
  touched: PropTypes.bool,
  hint: PropTypes.string,
  tooltipPosition: toolTipPropTypes.place,
  tooltipMessage: toolTipPropTypes.message,
  disabled: PropTypes.bool
};

const TjColorPicker = _ref => {
  let {
    name,
    label,
    required,
    validate,
    ...restProps
  } = _ref;
  const {
    input,
    meta: {
      error,
      touched,
      submitError
    }
  } = useField(name, {
    validate
  });
  return /*#__PURE__*/React__default.createElement(BasicColorPicker, _extends$A({
    label: label,
    required: required,
    name: name,
    touched: touched,
    error: touched && (error || submitError) ? error || submitError : null
  }, mergeSomeEvent(restProps, input)));
};
TjColorPicker.propTypes = {
  name: PropTypes.string,
  label: labelPropTypes.label,
  required: PropTypes.bool,
  validate: PropTypes.func
};

const fileUploadPropTypes = {
  name: PropTypes.string,
  title: PropTypes.string,
  btnVariant: PropTypes.oneOf(['primary', 'secondary']),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  changeFileLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  onChange: PropTypes.func,
  multiple: PropTypes.bool,
  disabled: PropTypes.bool,
  touched: PropTypes.bool,
  rules: PropTypes.shape({
    maxFileSize: PropTypes.number,
    minFileSize: PropTypes.number,
    acceptedFiles: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    maxFile: PropTypes.number,
    minFile: PropTypes.number,
    required: PropTypes.bool
  }),
  uploadEndPoint: PropTypes.string,
  listEndPoint: PropTypes.string,
  readEndPoint: PropTypes.string,
  deleteEndPoint: PropTypes.string,
  payload: PropTypes.shape({
    tenant_id: PropTypes.string,
    // eslint-disable-line
    branch_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    // eslint-disable-line
    public: PropTypes.bool,
    tag: PropTypes.string
  }),
  dataKey: PropTypes.string,
  requestHeaders: PropTypes.shape({
    Authorization: PropTypes.string
  }),
  component: PropTypes.elementType,
  hint: PropTypes.string,
  dragNDropTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  handleChange: PropTypes.func,
  handleClick: PropTypes.func,
  data: PropTypes.object,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
  fileDownloadFnc: PropTypes.func,
  fileRemoveFnc: PropTypes.func,
  id: PropTypes.string,
  shouldAutoUpload: PropTypes.bool,
  renderPreview: PropTypes.bool,
  shouldFetchFile: PropTypes.bool,
  showDownloadBtn: PropTypes.bool,
  showDeleteBtn: PropTypes.bool,
  downloadProcess: PropTypes.shape({
    _0: PropTypes.bool
  }),
  noWhiteBg: PropTypes.bool,
  dividerLabel: PropTypes.string,
  isWindowOpen: PropTypes.bool,
  afterUploaded: PropTypes.func,
  afterValidated: PropTypes.func,
  messageFormatter: PropTypes.func,
  tooltipMessage: toolTipPropTypes.title,
  required: PropTypes.bool,
  beingChange: PropTypes.bool,
  isVisible: PropTypes.bool
};

const fileConfigOptions = {
  options: {
    uploadEndPoint: 'https://test.test.com',
    readEndPoint: '',
    listEndPoint: '',
    deleteEndPoint: '',
    uploadRequestMethod: 'POST',
    listRequestMethod: 'GET',
    readRequestMethod: 'GET',
    deleteRequestMethod: 'DELETE',
    httpRequest: null,
    dataKey: '_id',
    uploadApiCommonPayload: {},
    shouldAutoUpload: true
  },
  merge(options) {
    this.options = {
      ...this.options,
      ...this.extractOptions(options)
    };
  },
  extractOptions(attrs) {
    const optionKeys = Object.keys(this.options);
    let data = {};
    optionKeys.forEach(k => {
      const val = attrs[k];
      if (val !== undefined) {
        data[k] = val;
      }
    });
    return data;
  }
};
const fileConfig = new Proxy(fileConfigOptions, {
  get(target, prop) {
    if (target.options[prop]) {
      return target.options[prop];
    }
    return Reflect.get(...arguments);
  }
});

const classNames$9 = require('classnames');
const FileItem = _ref => {
  let {
    uploading,
    fileName,
    error,
    onDelete,
    onDownload,
    showDownloadBtn = true,
    showDeleteBtn = true,
    downloading,
    isNew
  } = _ref;
  const containerClass = classNames$9({
    'tj-file-item-container': true,
    'has-error': error
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: containerClass,
    "data-testid": "file-item-container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "tj-file-item-wrapper "
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "tj-file-item-name-container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "file-name text-truncate",
    title: fileName
  }, fileName)), /*#__PURE__*/React__default.createElement("div", {
    className: "file-action-icon d-flex align-items-center justify-content-end"
  }, !isNew && showDownloadBtn ? /*#__PURE__*/React__default.createElement("button", {
    className: "btn btn-link btn-download highlight-on-hover",
    disabled: uploading || downloading,
    onClick: onDownload,
    type: "button"
  }, /*#__PURE__*/React__default.createElement(Icons.Download, null)) : null, isNew || showDeleteBtn ? /*#__PURE__*/React__default.createElement("button", {
    className: "btn btn-link btn-delete highlight-on-hover",
    disabled: uploading || downloading,
    onClick: onDelete,
    type: "button"
  }, /*#__PURE__*/React__default.createElement(Icons.Delete, null)) : null), (uploading || downloading) && /*#__PURE__*/React__default.createElement("div", {
    className: "progress"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "progress-bar progress-bar-striped progress-bar-animated",
    role: "progressbar",
    style: {
      width: '100%'
    }
  }))), error ? /*#__PURE__*/React__default.createElement(FeedbackMessage, {
    error: true,
    feedbackMessage: error
  }) : null);
};
FileItem.propTypes = {
  uploading: PropTypes.bool,
  fileName: PropTypes.string,
  error: PropTypes.string,
  isNew: PropTypes.bool,
  onDelete: PropTypes.func,
  downloading: PropTypes.bool,
  onDownload: PropTypes.func,
  showDeleteBtn: fileUploadPropTypes.showDeleteBtn,
  showDownloadBtn: fileUploadPropTypes.showDownloadBtn
};

const TjFilePreview = _ref => {
  let {
    data,
    value,
    fileRemoveFnc,
    fileDownloadFnc,
    error,
    dataKey = fileConfig.dataKey,
    showDownloadBtn,
    showDeleteBtn,
    downloadProcess
  } = _ref;
  const values = !isEmpty$1(value) && !isArray(value) ? [value] : !isEmpty$1(value) ? value : null;
  const uploading = useCallback(localId => {
    return data[localId] && data[localId].uploading ? true : false;
  }, [data]);
  const downloading = useCallback(index => {
    return downloadProcess && downloadProcess["_".concat(index)] ? downloadProcess["_".concat(index)] : false;
  }, [downloadProcess]);
  const getApiError = useCallback(localId => {
    return data[localId] && data[localId].apiError ? data[localId].apiError : false;
  }, [data]);
  const getError = useCallback(index => {
    if (isArray(error)) {
      return error[index];
    }
  }, [error]);
  const handleRemoveFile = useCallback(index => event => {
    event.stopPropagation();
    if (typeof fileRemoveFnc === 'function') {
      fileRemoveFnc(index);
    }
  }, [fileRemoveFnc]);
  const handleDownloadFile = useCallback(index => event => {
    event.stopPropagation();
    if (typeof fileDownloadFnc === 'function') {
      fileDownloadFnc(index);
    }
  }, [fileDownloadFnc]);
  if (!values) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "tj-file-items-container"
  }, values.map((fileObject, index) => {
    return /*#__PURE__*/React__default.createElement(FileItem, {
      key: fileObject[dataKey] || fileObject._localId || index,
      file: fileObject.file,
      error: getApiError(fileObject._localId) || getError(index),
      uploading: fileObject._localId ? uploading(fileObject._localId) : false,
      fileName: fileObject.fileName,
      onDelete: handleRemoveFile(index),
      isNew: !!fileObject._localId,
      downloading: downloading(index),
      onDownload: handleDownloadFile(index),
      showDeleteBtn: showDeleteBtn,
      showDownloadBtn: showDownloadBtn
    });
  }));
};
TjFilePreview.propTypes = {
  data: fileUploadPropTypes.data,
  value: fileUploadPropTypes.value,
  fileRemoveFnc: fileUploadPropTypes.fileRemoveFnc,
  fileDownloadFnc: fileUploadPropTypes.fileDownloadFnc,
  error: fileUploadPropTypes.error,
  showDownloadBtn: fileUploadPropTypes.showDownloadBtn,
  showDeleteBtn: fileUploadPropTypes.showDeleteBtn,
  dataKey: fileUploadPropTypes.dataKey,
  downloadProcess: fileUploadPropTypes.downloadProcess
};

/**
 *
 * @param config
 * @returns {*}
 */
const fileUploadRequest = config => {
  const httpRequest = fileConfig.httpRequest;
  if (!httpRequest) {
    throw new Error('httpRequest not found ');
  }
  return httpRequest(config);
};
const fileListRequest = config => {
  const httpRequest = fileConfig.httpRequest;
  if (!httpRequest) {
    throw new Error('httpRequest not found ');
  }
  return httpRequest(config);
};
const fileReadRequest = config => {
  const httpRequest = fileConfig.httpRequest;
  if (!httpRequest) {
    throw new Error('httpRequest not found ');
  }
  return httpRequest(config);
};
const fileDeleteRequest = config => {
  const httpRequest = fileConfig.httpRequest;
  if (!httpRequest) {
    throw new Error('httpRequest not found ');
  }
  return httpRequest(config);
};

function useDeepEffect(effectFunc, deps) {
  const isFirst = useRef(true);
  const prevDeps = useRef(deps);
  useEffect(() => {
    const isSame = prevDeps.current.every((obj, index) => isEqual(obj, deps[index]));
    if (isFirst.current || !isSame) {
      effectFunc();
    }
    isFirst.current = false;
    prevDeps.current = deps;
  }, [deps]);
}

const fileDownload = require('js-file-download');
const TjFileList = _ref => {
  let {
    payload,
    listEndPoint = fileConfig.listEndPoint,
    readEndPoint = fileConfig.readEndPoint,
    deleteEndPoint = fileConfig.deleteEndPoint,
    dataKey = fileConfig.dataKey,
    name,
    shouldFetchFile = false,
    multiple,
    requestHeaders,
    shouldAutoUpload = true,
    showDeleteBtn = true,
    showDownloadBtn = true
  } = _ref;
  const form = useForm();
  const fieldState = form.getFieldState(name);
  const formMutators = form.mutators;
  const fileRemove = formMutators.fileRemove;
  const {
    change: setFiles,
    value: files,
    data,
    error,
    submitError,
    touched
  } = fieldState ? fieldState : {};
  const _error = touched && (error || submitError) ? error || submitError : null;
  const [downloadProcess, setDownloadProcess] = useState({});
  const fetchList = async () => {
    try {
      if (!setFiles || !shouldFetchFile) {
        return;
      }
      const response = await fileListRequest({
        url: listEndPoint,
        method: fileConfig.listRequestMethod,
        params: payload,
        headers: {
          ...requestHeaders
        }
      });
      setFiles(isArray(response.data) ? multiple ? response.data : response.data[0] ? response.data[0] : '' : []);
    } catch (error) {
      console.log('Getting Error to Fetch the list', error);
    }
  };
  const deleteFile = async index => {
    const _id = multiple ? files[index][dataKey] : files[dataKey];
    fileRemove(name, index);
    if (!_id || !shouldAutoUpload || !deleteEndPoint) {
      return;
    }
    try {
      await fileDeleteRequest({
        url: "".concat(deleteEndPoint, "/").concat(_id),
        method: fileConfig.deleteRequestMethod,
        headers: {
          ...requestHeaders
        }
      });
    } catch (error) {
      console.log('Getting Error to delete the file', error);
    }
  };
  const downloadFile = async index => {
    const _file = multiple ? files[index] : files;
    const _id = _file[dataKey];
    const type = _file.type && _file.type.mime ? _file.type.mime : '';
    try {
      setDownloadProcess({
        ...downloadProcess,
        ["_".concat(index)]: true
      });
      let url = '';
      let baseURL = undefined;
      if (!shouldAutoUpload) {
        url = _file.file;
      } else if (_file.file instanceof File) {
        baseURL = '';
        url = await toBase64(_file.file, false);
      } else {
        url = "".concat(readEndPoint, "/").concat(_id);
      }
      const response = await fileReadRequest({
        url,
        method: fileConfig.readRequestMethod,
        headers: {
          accept: type,
          'Content-Type': type,
          ...requestHeaders
        },
        baseURL,
        responseType: 'blob'
      });
      if (!response) {
        return;
      }
      fileDownload(response.data, _file.fileName);
    } catch (error) {
      console.log('Getting Error to download the file', error);
    }
    setDownloadProcess({
      ...downloadProcess,
      ["_".concat(index)]: false
    });
  };
  useDeepEffect(() => {
    fetchList();
  }, [payload, listEndPoint, setFiles, multiple, shouldFetchFile]);
  return /*#__PURE__*/React__default.createElement(TjFilePreview, {
    data: data,
    value: files,
    fileRemoveFnc: deleteFile,
    fileDownloadFnc: downloadFile,
    error: _error,
    showDeleteBtn: showDeleteBtn,
    showDownloadBtn: showDownloadBtn,
    downloadProcess: downloadProcess
  });
};
TjFileList.propTypes = {
  listEndPoint: fileUploadPropTypes.listEndPoint,
  readEndPoint: fileUploadPropTypes.readEndPoint,
  deleteEndPoint: fileUploadPropTypes.deleteEndPoint,
  payload: fileUploadPropTypes.payload,
  requestHeaders: fileUploadPropTypes.requestHeaders,
  shouldAutoUpload: fileUploadPropTypes.shouldAutoUpload,
  showDeleteBtn: fileUploadPropTypes.showDeleteBtn,
  showDownloadBtn: fileUploadPropTypes.showDownloadBtn,
  dataKey: fileUploadPropTypes.dataKey,
  name: fileUploadPropTypes.name,
  shouldFetchFile: fileUploadPropTypes.shouldFetchFile,
  multiple: fileUploadPropTypes.multiple
};

const RawFileUpload = _ref => {
  let {
    component,
    name,
    onChange,
    multiple,
    label,
    id,
    disabled,
    ...restProps
  } = _ref;
  const fileRef = useRef(null);
  const [isWindowOpen, setWindowOpen] = useState(false);
  const handleChange = useCallback(_ref2 => {
    let {
      target
    } = _ref2;
    const files = [];
    Array.from(target.files).forEach(file => {
      const fileName = file.name.toString().normalize();
      files.push({
        _localId: guidGenerator(),
        fileName,
        file
      });
    });
    target.value = null;
    if (typeof onChange === 'function') {
      onChange(files);
    }
  }, [onChange]);
  function setFocus() {
    document.body.onfocus = unfocus.bind(undefined, setWindowOpen);
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "file-group raw-file-upload-group"
  }, /*#__PURE__*/React__default.createElement("input", {
    ref: fileRef,
    name: name,
    id: id,
    type: "file",
    disabled: disabled,
    multiple: multiple,
    onChange: handleChange,
    onClick: setFocus
  }), component ? ( /*#__PURE__*/React__default.createElement(component, {
    handleChange,
    handleClick: handleRawFileBtnClick.bind(undefined, fileRef, setWindowOpen),
    label,
    name,
    disabled,
    multiple,
    isWindowOpen,
    ...restProps
  })) : /*#__PURE__*/React__default.createElement(TjButton, {
    disabled: disabled,
    type: "button",
    onClick: handleRawFileBtnClick.bind(undefined, fileRef, setWindowOpen)
  }, label));
};
RawFileUpload.propTypes = {
  name: fileUploadPropTypes.name.isRequired,
  multiple: fileUploadPropTypes.multiple,
  label: fileUploadPropTypes.label.isRequired,
  onChange: fileUploadPropTypes.onChange,
  component: fileUploadPropTypes.component,
  disabled: fileUploadPropTypes.disabled,
  id: fileUploadPropTypes.id
};
const handleRawFileBtnClick = (fileRef, setWindowOpen, e) => {
  e.stopPropagation();
  fileRef.current.click();
  setWindowOpen(true);
};
function unfocus(setWindowOpen) {
  setWindowOpen(false);
  document.body.onfocus = null;
}

const BasicFileUpload = _ref => {
  let {
    dragNDropTitle,
    hint,
    error,
    name,
    component,
    ...restProps
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "input-group"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/React__default.createElement(RawFileUpload, _extends$A({
    component: component,
    name: name,
    hint: hint,
    error: error,
    dragNDropTitle: dragNDropTitle
  }, restProps))), error && typeof error !== 'object' && /*#__PURE__*/React__default.createElement(FeedbackMessage, {
    feedbackMessage: error,
    error: true
  }));
};
BasicFileUpload.propTypes = {
  name: fileUploadPropTypes.name,
  hint: fileUploadPropTypes.hint,
  error: fileUploadPropTypes.error,
  dragNDropTitle: fileUploadPropTypes.dragNDropTitle,
  touched: fileUploadPropTypes.touched,
  component: fileUploadPropTypes.component
};

/**
 * To get the file extension.
 *
 * @param {String} name
 *
 * @returns {String}
 */
function getFileExt(name) {
  let nameArray = name.split('.');
  return nameArray[nameArray.length - 1];
}
const fileErrorMessage = (rules, errorType, attribute) => {
  if (rules && typeof rules.message === 'function') {
    return rules.message(errorType, attribute);
  }
  return errorType;
};

/**
 * To verify the file Extensions
 *
 * @param {Array} acceptedFiles
 * @param {File Instance} file
 *
 * @returns boolean
 */
function checkFileExtensions(acceptedFiles, file) {
  const fileName = file.name;
  const fileType = file.type;
  let isValid = false;
  acceptedFiles.forEach(function (_fileType) {
    if (_fileType.startsWith('.')) {
      let ext = getFileExt(fileName);
      let pattern = new RegExp(_fileType.replace('.', ''), 'gmi');
      if (pattern.test(ext) === true) {
        isValid = true;
      }
    } else {
      let matchString = _fileType;
      let pattern = '';
      if (_fileType.endsWith('*')) {
        matchString.slice(0, -1);
        pattern = new RegExp('^' + matchString, 'gmi');
      } else {
        pattern = new RegExp(matchString, 'gmi');
      }
      if (pattern.test(fileType) === true) {
        isValid = true;
      }
    }
  });
  return isValid;
}

/**
 * To Validate the File on various rules.
 *
 * @param {File} file File instance
 * @param {Object} rules Validation Rules
 *
 * @returns Promise
 */
async function fileValidation(file, rules) {
  if (!(file instanceof File || file instanceof Blob)) {
    return null;
  }
  const message = fileErrorMessage.bind(undefined, rules);
  const {
    maxFileSize,
    minFileSize,
    acceptedFiles
  } = rules;
  const maxFileSizeBytes = maxFileSize ? maxFileSize * 1000000 : null;
  const minFileSizeBytes = minFileSize ? minFileSize * 1000000 : null;
  const acceptedFilesArr = acceptedFiles ? isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.toString().split(',') : null;
  return new Promise(function (resolve) {
    const errors = [];
    const fReader = new FileReader();
    fReader.onload = function (e) {
      const attribute = {
        maxFileSize,
        minFileSize,
        maxFileSizeBytes,
        minFileSizeBytes,
        actualFileSizeBytes: e.total,
        acceptedFiles
      };

      /**
       * Checking file extensions
       */
      if (acceptedFilesArr && !checkFileExtensions(acceptedFilesArr, file)) {
        errors.push(message('acceptedFiles', attribute));
      }

      /**
       * Checking file size for max size validation
       */
      if (maxFileSizeBytes && e.total > maxFileSizeBytes) {
        errors.push(message('maxFileSize', attribute));
      }

      /**
       * Checking file size for min validation
       */
      if (minFileSizeBytes && e.total < minFileSizeBytes) {
        errors.push(message('minFileSize', attribute));
      }

      /**
       * Resolving the promise instance
       */
      resolve(errors.length ? errors[0] : null);
    };
    fReader.readAsDataURL(file);
  });
}

/**
 * To Validate the file field based on react-final form rules.
 *
 * @param {object} rules -> file validation rule schema
 * @param {Array} files collection of selected file.
 *
 * @returns string | Array[string]
 */
async function validateFile(_ref, value) {
  let {
    rules,
    validationSucceed,
    fileValidating,
    fileValidated
  } = _ref;
  const files = value && !isArray(value) ? [value] : isArray(value) ? value : [];
  const message = fileErrorMessage.bind(undefined, rules);
  const isEmptyValue = !isArray(files) || !files.length;
  if (!rules || !rules.required && isEmptyValue) {
    return;
  }
  if (rules.required && isEmptyValue) {
    return message('required');
  }
  if (rules.maxFile && files.length > rules.maxFile) {
    return message('maxFile');
  }
  if (rules.minFile && files.length < rules.minFile) {
    return message('minFile');
  }
  const errors = [];
  for (let i = 0; i < files.length; i++) {
    const fileObject = files[i];
    const localId = fileObject._localId;
    if (!localId) {
      errors.push(undefined);
      continue;
    }
    const previousError = fileValidated.current[localId];
    if (previousError) {
      errors.push(previousError);
      continue;
    }
    fileValidating.current.push(localId);
    const error = await fileValidation(fileObject.file, rules);
    if (error) {
      errors.push(error);
    } else {
      errors.push(undefined);
      validationSucceed.current.push(localId);
    }
    const index = fileValidating.current.indexOf(localId);
    if (index !== -1) {
      fileValidating.current.splice(index, 1);
    }
    fileValidated.current[localId] = error;
  }
  const hasAtLeastOneError = errors.some(e => !!e);
  return hasAtLeastOneError ? errors : undefined;
}

const classNames$8 = require('classnames');
const TjFileUpload = _ref => {
  let {
    name,
    disabled,
    title,
    label,
    multiple,
    rules = {},
    uploadEndPoint = fileConfig.uploadEndPoint,
    payload,
    dataKey = fileConfig.dataKey,
    requestHeaders,
    dragNDropTitle,
    component,
    shouldAutoUpload = fileConfig.shouldAutoUpload,
    listEndPoint,
    readEndPoint,
    deleteEndPoint,
    renderPreview = true,
    showDeleteBtn = true,
    showDownloadBtn = true,
    shouldFetchFile = false,
    afterUploaded,
    afterValidated,
    messageFormatter,
    beingChange,
    isVisible = true,
    ...restProps
  } = _ref;
  const validationSucceed = useRef([]);
  const fileValidating = useRef([]);
  const fileUploaded = useRef([]);
  const fileUploading = useRef([]);
  const fileValidated = useRef({});
  const form = useForm('fileUploader');
  const formMutators = form.mutators;
  const hasMutators = !!(formMutators && formMutators.setFileTouch && formMutators.fileUpdate && formMutators.fileConcat && formMutators.fileUpload);
  if (!hasMutators) {
    throw new Error('File mutators not found. You need to provide the mutators from mutators to your form');
  }
  const mutators = useMemo(() => {
    return Object.keys(formMutators).reduce((result, key) => {
      result[key] = function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return formMutators[key](name, ...args);
      };
      return result;
    }, {});
  }, []);
  const handleAfterValidated = () => {
    if (!shouldAutoUpload) {
      return;
    }
    const uploadedFilesResponse = [];
    const filesLength = validationSucceed.current.length;
    if (!filesLength) return;
    return new Promise(resolve => validationSucceed.current.forEach(async (id, index) => {
      if (!fileUploading.current.includes(id) && !fileUploaded.current.includes(id)) {
        fileUploading.current.push(id);
        const response = await mutators.fileUpload(id, {
          uploadEndPoint,
          payload,
          uploading: mutators.uploading,
          apiError: mutators.apiError,
          fileUpdate: mutators.fileUpdate,
          multiple,
          rules: {
            ...rules,
            message: messageFormatter
          },
          requestHeaders
        });
        uploadedFilesResponse.push(response);
        fileUploaded.current.push(id);
        const index = fileUploading.current.indexOf(id);
        if (index !== -1) {
          fileUploading.current.splice(index, 1);
        }
      }
      const isLastFile = filesLength === index + 1;
      if (isLastFile) {
        resolve(true);
      }

      // Last file
      if (isLastFile && uploadedFilesResponse.length && typeof afterUploaded === 'function') {
        afterUploaded(uploadedFilesResponse);
      }
    }));
  };
  const {
    input: {
      onChange,
      value
    },
    meta: {
      error,
      touched,
      validating,
      submitError,
      submitting,
      data
    }
  } = useField(name, {
    multiple
  });
  useEffect(() => {
    const unsubscribe = form.registerField(name, () => {}, {
      value: true
    }, {
      getValidator: () => {
        return async value => {
          if (!isVisible) {
            return;
          }
          const response = await validateFile({
            rules: {
              ...rules,
              message: messageFormatter
            },
            validationSucceed,
            fileValidating,
            fileValidated
          }, value);
          if (typeof afterValidated === 'function') {
            afterValidated(response);
          }
          await handleAfterValidated();
          return response;
        };
      }
    });
    return unsubscribe;
  }, [shouldAutoUpload, rules.required, beingChange, isVisible]);
  const handleChange = useCallback(files => {
    mutators.setFileTouch(true);
    if (!multiple) {
      onChange(files[0]);
    } else {
      mutators.fileConcat(files);
    }
  }, []);
  const isDisabled = disabled || validating || submitting;
  const _error = touched && (error || submitError) ? error || submitError : null;
  const containerClass = classNames$8({
    'tj-file-wrapper': true,
    'has-error': _error && typeof _error === 'string'
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: containerClass,
    "data-testid": "tj-file-upload-main-container"
  }, /*#__PURE__*/React__default.createElement(BasicFileUpload, _extends$A({
    title: title,
    label: label,
    name: name,
    dragNDropTitle: dragNDropTitle,
    touched: touched,
    multiple: multiple,
    disabled: isDisabled,
    component: component,
    dataKey: dataKey,
    error: _error,
    data: data,
    value: value,
    shouldAutoUpload: shouldAutoUpload,
    listEndPoint: listEndPoint,
    readEndPoint: readEndPoint,
    deleteEndPoint: deleteEndPoint,
    renderPreview: renderPreview,
    shouldFetchFile: shouldFetchFile,
    showDeleteBtn: showDeleteBtn,
    showDownloadBtn: showDownloadBtn
  }, mergeSomeEvent(restProps, {
    onChange: handleChange
  }))));
};
TjFileUpload.propTypes = {
  name: fileUploadPropTypes.name.isRequired,
  title: fileUploadPropTypes.title,
  label: fileUploadPropTypes.label.isRequired,
  multiple: fileUploadPropTypes.multiple,
  rules: fileUploadPropTypes.rules,
  disabled: fileUploadPropTypes.disabled,
  uploadEndPoint: fileUploadPropTypes.uploadEndPoint,
  payload: fileUploadPropTypes.payload,
  dataKey: fileUploadPropTypes.dataKey,
  requestHeaders: fileUploadPropTypes.requestHeaders,
  dragNDropTitle: fileUploadPropTypes.dragNDropTitle,
  component: fileUploadPropTypes.component,
  shouldAutoUpload: fileUploadPropTypes.shouldAutoUpload,
  listEndPoint: fileUploadPropTypes.listEndPoint,
  deleteEndPoint: fileUploadPropTypes.deleteEndPoint,
  readEndPoint: fileUploadPropTypes.readEndPoint,
  shouldFetchFile: fileUploadPropTypes.shouldFetchFile,
  showDeleteBtn: fileUploadPropTypes.showDeleteBtn,
  showDownloadBtn: fileUploadPropTypes.showDownloadBtn,
  renderPreview: fileUploadPropTypes.renderPreview,
  afterUploaded: fileUploadPropTypes.afterUploaded,
  afterValidated: fileUploadPropTypes.afterValidated,
  messageFormatter: fileUploadPropTypes.messageFormatter,
  beingChange: fileUploadPropTypes.beingChange,
  isVisible: fileUploadPropTypes.isVisible
};

const fileSelectorPropTypes = {
  handleChange: fileUploadPropTypes.handleChange.isRequired,
  handleClick: fileUploadPropTypes.handleClick.isRequired,
  label: fileUploadPropTypes.label.isRequired,
  title: fileUploadPropTypes.title,
  required: fileUploadPropTypes.required,
  tooltipMessage: fileUploadPropTypes.tooltipMessage,
  disabled: fileUploadPropTypes.disabled,
  hint: fileUploadPropTypes.hint,
  data: fileUploadPropTypes.data,
  value: fileUploadPropTypes.value,
  fileRemoveFnc: fileUploadPropTypes.fileRemoveFnc,
  error: fileUploadPropTypes.error,
  changeFileLabel: fileUploadPropTypes.changeFileLabel,
  renderPreview: fileUploadPropTypes.renderPreview,
  payload: fileUploadPropTypes.payload,
  listEndPoint: fileUploadPropTypes.listEndPoint,
  deleteEndPoint: fileUploadPropTypes.deleteEndPoint,
  readEndPoint: fileUploadPropTypes.readEndPoint,
  dataKey: fileUploadPropTypes.dataKey,
  shouldFetchFile: fileUploadPropTypes.shouldFetchFile,
  showDeleteBtn: fileUploadPropTypes.showDeleteBtn,
  showDownloadBtn: fileUploadPropTypes.showDownloadBtn,
  shouldAutoUpload: fileUploadPropTypes.shouldAutoUpload,
  multiple: fileUploadPropTypes.multiple,
  requestHeaders: fileUploadPropTypes.requestHeaders,
  name: fileUploadPropTypes.name,
  id: fileUploadPropTypes.id,
  noWhiteBg: fileUploadPropTypes.noWhiteBg,
  isWindowOpen: fileUploadPropTypes.isWindowOpen,
  dragNDropTitle: fileUploadPropTypes.dragNDropTitle,
  dividerLabel: fileUploadPropTypes.dividerLabel
};

const TjFileSelectorDesktopVersion = _ref => {
  let {
    handleChange,
    handleClick,
    disabled,
    hint,
    dragNDropTitle,
    label,
    payload,
    listEndPoint,
    readEndPoint,
    deleteEndPoint,
    renderPreview = true,
    dataKey,
    shouldFetchFile = false,
    showDeleteBtn = true,
    showDownloadBtn = true,
    shouldAutoUpload,
    name,
    id,
    multiple,
    requestHeaders,
    dividerLabel = 'OR'
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "card tj-file-card",
    onDrop: handleFileDrop.bind(undefined, handleChange, disabled),
    onDragOver: handleFileDragOver
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "card-body"
  }, renderPreview ? /*#__PURE__*/React__default.createElement(TjFileList, {
    payload: payload,
    listEndPoint: listEndPoint,
    readEndPoint: readEndPoint,
    deleteEndPoint: deleteEndPoint,
    dataKey: dataKey,
    name: name,
    shouldAutoUpload: shouldAutoUpload,
    shouldFetchFile: shouldFetchFile,
    multiple: multiple,
    requestHeaders: requestHeaders,
    showDeleteBtn: showDeleteBtn,
    showDownloadBtn: showDownloadBtn
  }) : null, /*#__PURE__*/React__default.createElement("div", {
    className: "tj-drag-container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "tj-drag-body"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "highlight-color"
  }, /*#__PURE__*/React__default.createElement(Icons.UploadCv, null)), /*#__PURE__*/React__default.createElement("div", {
    className: "tj-drag-n-drop-title"
  }, dragNDropTitle && /*#__PURE__*/React__default.createElement("h4", null, dragNDropTitle))), /*#__PURE__*/React__default.createElement("div", {
    className: "or-divider"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "line"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "or"
  }, dividerLabel), /*#__PURE__*/React__default.createElement("div", {
    className: "line"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "tj-selector-body"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "tj-file-button-wrapper"
  }, /*#__PURE__*/React__default.createElement(TjButton, {
    type: "button",
    "data-testid": "file-modal-box-btn",
    disabled: disabled,
    name: name,
    id: id || name,
    onClick: handleClick
  }, label), hint && /*#__PURE__*/React__default.createElement(FeedbackMessage, {
    error: false,
    feedbackMessage: hint
  }))))));
};
TjFileSelectorDesktopVersion.propTypes = fileSelectorPropTypes;
const handleFileDrop = (handleChange, disabled, e) => {
  e.preventDefault();
  e.stopPropagation();
  if (!e.dataTransfer.files || disabled) {
    return;
  }
  if (typeof handleChange === 'function') {
    handleChange({
      target: e.dataTransfer
    });
  }
};
const handleFileDragOver = e => {
  e.preventDefault();
  e.stopPropagation();
};

const classNames$7 = require('classnames');
const TjFileSelectorMobileVersion = _ref => {
  let {
    handleClick,
    disabled,
    hint,
    label,
    payload,
    listEndPoint,
    readEndPoint,
    deleteEndPoint,
    renderPreview = true,
    dataKey,
    shouldFetchFile = false,
    showDeleteBtn = true,
    showDownloadBtn = true,
    shouldAutoUpload,
    noWhiteBg = false,
    name,
    multiple,
    value,
    changeFileLabel,
    requestHeaders,
    id,
    btnVariant = 'primary'
  } = _ref;
  const values = makeValueArray(value);
  const hasValue = !!values;
  const containerClass = classNames$7({
    card: true,
    'tj-file-card': true,
    'm-version': true,
    'has-value': hasValue,
    'white-bg': !noWhiteBg && hasValue
  });
  return /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "mversion-file-container",
    className: containerClass
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "card-body"
  }, renderPreview ? /*#__PURE__*/React__default.createElement(TjFileList, {
    payload: payload,
    listEndPoint: listEndPoint,
    readEndPoint: readEndPoint,
    deleteEndPoint: deleteEndPoint,
    dataKey: dataKey,
    name: name,
    shouldFetchFile: shouldFetchFile,
    multiple: multiple,
    requestHeaders: requestHeaders,
    showDeleteBtn: showDeleteBtn,
    showDownloadBtn: showDownloadBtn,
    shouldAutoUpload: shouldAutoUpload
  }) : null, /*#__PURE__*/React__default.createElement("div", {
    className: "tj-selector-body"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "tj-file-button-wrapper"
  }, /*#__PURE__*/React__default.createElement(TjButton, {
    type: "button",
    variant: btnVariant,
    name: name,
    id: id || name,
    disabled: disabled,
    onClick: handleClick
  }, hasValue ? changeFileLabel || label : label), hint && /*#__PURE__*/React__default.createElement(FeedbackMessage, {
    error: false,
    feedbackMessage: hint
  })))));
};
TjFileSelectorMobileVersion.propTypes = fileUploadPropTypes;

const classNames$6 = require('classnames');
const TjFileSelectorApplicationForm = _ref => {
  let {
    handleClick,
    disabled,
    hint,
    label,
    title,
    payload,
    listEndPoint,
    readEndPoint,
    deleteEndPoint,
    renderPreview = true,
    dataKey,
    shouldFetchFile = false,
    showDeleteBtn = true,
    showDownloadBtn = true,
    shouldAutoUpload,
    noWhiteBg = false,
    name,
    multiple,
    value,
    changeFileLabel,
    requestHeaders,
    error,
    isWindowOpen,
    tooltipMessage,
    required,
    id
  } = _ref;
  const _id = id || name;
  const values = makeValueArray(value);
  const hasValue = !!values;
  const focusClassName = isWindowOpen ? 'focus' : '';
  const containerClass = classNames$6({
    'tj-file-container-application-form': true,
    'has-value': hasValue,
    'white-bg': !noWhiteBg && hasValue,
    bg: true
  });
  const cardBodyClass = classNames$6({
    'required-error': required && error && typeof error === 'string'
  });
  return /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "file-container",
    className: containerClass
  }, title && /*#__PURE__*/React__default.createElement(Label, {
    className: "tj-form-label mb8",
    label: title,
    required: required,
    htmlFor: _id,
    disabled: disabled,
    tooltipMessage: tooltipMessage
  }), renderPreview ? /*#__PURE__*/React__default.createElement(TjFileList, {
    payload: payload,
    listEndPoint: listEndPoint,
    readEndPoint: readEndPoint,
    deleteEndPoint: deleteEndPoint,
    dataKey: dataKey,
    name: name,
    shouldFetchFile: shouldFetchFile,
    multiple: multiple,
    requestHeaders: requestHeaders,
    showDeleteBtn: showDeleteBtn,
    showDownloadBtn: showDownloadBtn,
    shouldAutoUpload: shouldAutoUpload
  }) : null, /*#__PURE__*/React__default.createElement("div", {
    className: "card-message-container ".concat(focusClassName)
  }, !hasValue ? /*#__PURE__*/React__default.createElement("div", {
    onClick: handleClick,
    role: "button",
    tabIndex: -1,
    onKeyDown: () => {},
    className: "card-body ".concat(cardBodyClass)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "tj-file-button-wrapper"
  }, /*#__PURE__*/React__default.createElement(TjButton, {
    type: "button",
    id: _id,
    disabled: disabled,
    onClick: handleClick
  }, hasValue ? changeFileLabel || label : label))) : null, hint && !hasValue && !error && /*#__PURE__*/React__default.createElement(FeedbackMessage, {
    error: false,
    feedbackMessage: hint
  })));
};
TjFileSelectorApplicationForm.propTypes = fileSelectorPropTypes;

/* eslint-disable camelcase */
const fileMutators = {
  setFileTouch: (_ref, state) => {
    let [name, status] = _ref;
    const field = state.fields[name];
    if (!field) {
      return;
    }
    field.touched = status;
  },
  fileUpdate: (_ref2, state, _ref3) => {
    let [name, index, value] = _ref2;
    let {
      changeValue
    } = _ref3;
    changeValue(state, name, oldValue => {
      if (index !== undefined) {
        return oldValue.map((v, i) => {
          if (index === i) {
            return {
              ...v,
              ...value
            };
          } else {
            return v;
          }
        });
      } else {
        return {
          ...oldValue,
          ...value
        };
      }
    });
  },
  fileConcat: (_ref4, state, _ref5) => {
    let [name, value] = _ref4;
    let {
      changeValue
    } = _ref5;
    changeValue(state, name, oldValue => {
      const fileValue = oldValue ? oldValue : [];
      return [...fileValue, ...value];
    });
  },
  fileRemove: (_ref6, state, _ref7) => {
    let [name, index] = _ref6;
    let {
      getIn,
      changeValue
    } = _ref7;
    const value = getIn(state.formState.values, name);
    const field = state.fields[name];
    if (!isArray(value) && value) {
      changeValue(state, name, () => '');
      if (value._localId) {
        delete field.data[value._localId];
      }
    }
    if (isArray(value)) {
      changeValue(state, name, oldValue => {
        const valueCopy = [...oldValue];
        valueCopy.splice(index, 1);
        return valueCopy;
      });
      const _localId = value[index] && value[index]._localId ? value[index]._localId : false;
      if (_localId) {
        delete field.data[_localId];
      }
    }
  },
  uploading: (_ref8, state) => {
    let [name, id, status] = _ref8;
    const field = state.fields[name];
    if (!field) {
      return;
    }
    if (!field.data[id]) {
      field.data[id] = {};
    }
    field.data[id]['uploading'] = status;
    if (status) {
      delete field.data[id]['apiError'];
    }
  },
  apiError: (_ref9, state) => {
    let [name, id, error] = _ref9;
    const field = state.fields[name];
    if (!field) {
      return;
    }
    if (!field.data[id]) {
      field.data[id] = {};
    }
    field.data[id]['apiError'] = error;
  },
  fileUpload: async (_ref10, state, _ref11) => {
    let [name, id, {
      apiError,
      uploadEndPoint,
      payload,
      uploading,
      fileUpdate,
      multiple,
      rules,
      requestHeaders
    }] = _ref10;
    let {
      getIn
    } = _ref11;
    let fileObject;
    let fileIndex;
    const value = getIn(state.formState.values, name);
    if (multiple && isArray(value)) {
      fileIndex = value.findIndex(f => f._localId === id);
      fileObject = value[fileIndex] ? value[fileIndex] : {};
    } else {
      fileObject = value;
    }
    if (!fileObject._localId || !fileObject.file) {
      return;
    }
    const file = fileObject.file;
    const mime = fileObject.file.type;
    const ext = mime.substring(mime.indexOf('/') + 1);
    const fileType = {
      mime,
      ext
    };
    if (fileConfig.uploadApiCommonPayload.branch_id === 'main') {
      fileConfig.uploadApiCommonPayload.branch_id = '1';
    }
    let response = null;
    try {
      uploading(id, true);
      response = await fileUploadRequest({
        method: fileConfig.uploadRequestMethod,
        headers: requestHeaders,
        data: {
          ...fileConfig.uploadApiCommonPayload,
          ...payload,
          type: fileType,
          fileName: fileObject.fileName
        },
        url: uploadEndPoint
      });
      const data = response.data ? response.data : {};
      if (!(Object.keys(data).length === 0)) {
        await uploadFileToS3(data.signed_url, file);
      }
      if (multiple) {
        fileUpdate(fileIndex, {
          ...data,
          _localId: undefined
        });
      } else {
        fileUpdate(undefined, {
          ...data,
          _localId: undefined
        });
      }
    } catch (error) {
      const errorMessage = error.response && error.response.data && error.response.data.message ? error.response.data.message : 'unknown';
      apiError(id, fileErrorMessage(rules, errorMessage));
    }
    uploading(id, false);
    return response;
  }
};

const notification = PropTypes.shape({
  id: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType, PropTypes.element]),
  position: PropTypes.oneOf(['bottom-center', 'bottom-left', 'bottom-right', 'top-left', 'top-right', 'top-center']),
  hidden: PropTypes.bool,
  timeout: PropTypes.number,
  type: PropTypes.oneOf(['error', 'info', 'success'])
});
const notificationPropTypes = {
  notification,
  notifications: PropTypes.arrayOf(notification),
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType, PropTypes.element]),
  position: PropTypes.oneOf(['bottom-center', 'bottom-left', 'bottom-right', 'top-left', 'top-right', 'top-center']),
  timeout: PropTypes.number,
  type: PropTypes.oneOf(['error', 'info', 'success']),
  onClose: PropTypes.func,
  children: PropTypes.element,
  hidden: PropTypes.bool
};

const NotificationIcon = {
  error: Icons.NotificationError,
  info: Icons.NotificationInfo,
  success: Icons.NotificationSuccess
};
const animationOnShow = {
  'bottom-center': 'animate__fadeInUp',
  'bottom-left': 'animate__fadeInLeft',
  'bottom-right': 'animate__fadeInRight',
  'top-center': 'animate__fadeInDown',
  'top-left': 'animate__fadeInLeft',
  'top-right': 'animate__fadeInRight'
};
const animationOnHide = {
  'bottom-center': 'animate__fadeOutDown',
  'bottom-left': 'animate__fadeOutLeft',
  'bottom-right': 'animate__fadeOutRight',
  'top-center': 'animate__fadeOutUp',
  'top-left': 'animate__fadeOutLeft',
  'top-right': 'animate__fadeOutRight'
};
const NotificationItem = _ref => {
  let {
    id,
    message,
    position,
    timeout,
    type,
    onClose,
    hidden
  } = _ref;
  const timer = useRef();
  const closeCallback = useCallback(() => {
    if (timer.current) {
      timer.current.destroy();
    }
    timer.current = undefined;
    if (typeof onClose === 'function') {
      onClose(id);
    }
  }, [id]);
  const handleMouseEnter = useCallback(() => {
    if (timer.current) {
      timer.current.pause();
    }
  }, []);
  const handleMouseLeave = useCallback(() => {
    if (timer.current) {
      timer.current.resume();
    }
  }, []);
  useEffect(() => {
    if (timeout) {
      timer.current = new Timer(closeCallback, timeout);
    }
    return () => {
      if (timer.current) {
        timer.current.destroy();
      }
    };
  }, [timeout]);
  return /*#__PURE__*/React__default.createElement("div", {
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    "data-testid": "tj-notification-item-body",
    className: "animate__animated animate__faster tj-notification-item-body ".concat(type, " ").concat(hidden ? animationOnHide[position] : animationOnShow[position])
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "tj-notification-item-icon"
  }, /*#__PURE__*/React__default.createElement(NotificationIcon[type])), /*#__PURE__*/React__default.createElement("div", {
    className: "tj-notification-item-message",
    "data-testid": "tj-notification-item-message"
  }, message));
};
NotificationItem.propTypes = {
  id: PropTypes.string.isRequired,
  message: notificationPropTypes.message.isRequired,
  timeout: notificationPropTypes.timeout,
  type: notificationPropTypes.type,
  hidden: notificationPropTypes.hidden,
  onClose: notificationPropTypes.onClose,
  position: notificationPropTypes.position
};

const NotificationContainer = _ref => {
  let {
    notifications,
    onClose
  } = _ref;
  const positionNotifications = useMemo(() => {
    return groupBy(notifications, 'position');
  }, [notifications]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "tj-notifications-container",
    "data-testid": "tj-notifications-container"
  }, Object.keys(positionNotifications).map(position => {
    return /*#__PURE__*/React__default.createElement("div", {
      key: position,
      className: "tj-notification-item-container ".concat(position)
    }, positionNotifications[position].map(notification => /*#__PURE__*/React__default.createElement(NotificationItem, _extends$A({
      onClose: onClose
    }, notification, {
      key: notification.id
    }))));
  }));
};
NotificationContainer.propTypes = {
  notifications: notificationPropTypes.notifications,
  onClose: notificationPropTypes.onClose
};

const TjNotificationContext = /*#__PURE__*/React__default.createContext();

const TjNotificationProvider = _ref => {
  let {
    children
  } = _ref;
  const [{
    notifications
  }, dispatch] = useReducer(notificationReducer, {
    notifications: []
  });
  const showNotification = function (message) {
    let {
      type = 'success',
      position = 'bottom-center',
      timeout = 10000
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const notification = {
      id: guidGenerator(),
      message,
      type,
      position,
      timeout
    };
    dispatch({
      type: 'ADD',
      payload: {
        notification
      }
    });
  };
  const deleteNotification = id => {
    dispatch({
      type: 'DELETE',
      payload: {
        id
      }
    });
  };
  const hideNotification = id => {
    dispatch({
      type: 'HIDDEN',
      payload: {
        id
      }
    });
    setTimeout(() => {
      deleteNotification(id);
    }, 500);
  };
  return /*#__PURE__*/React__default.createElement(TjNotificationContext.Provider, {
    value: {
      showNotification,
      deleteNotification,
      hideNotification
    }
  }, children, /*#__PURE__*/React__default.createElement(NotificationContainer, {
    notifications: notifications,
    onClose: hideNotification
  }));
};
TjNotificationProvider.propTypes = {
  children: notificationPropTypes.children
};
function notificationReducer(state, action) {
  switch (action.type) {
    case 'ADD':
      return {
        ...state,
        notifications: [action.payload.notification, ...state.notifications]
      };
    case 'DELETE':
      return {
        ...state,
        notifications: state.notifications.filter(notification => notification.id !== action.payload.id)
      };
    case 'HIDDEN':
      return {
        ...state,
        notifications: state.notifications.map(notification => {
          if (notification.id === action.payload.id) {
            notification.hidden = true;
          }
          return {
            ...notification
          };
        })
      };
    default:
      return state;
  }
}

const TjProgressBar = _ref => {
  let {
    percentage
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "tj-progress-bar-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "tj-progress-bar-completed bg-gradient",
    "data-testid": "tj-progress-bar-completed ",
    style: {
      width: "".concat(percentage, "%")
    }
  }));
};
TjProgressBar.propTypes = {
  percentage: PropTypes.number.isRequired
};

const Shimmer = () => {
  return /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "shimmer",
    className: "shimmer-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "shimmer"
  }));
};

const Skeleton = _ref => {
  let {
    type,
    animation = false
  } = _ref;
  const classes = "skeleton ".concat(type);
  return /*#__PURE__*/React__default.createElement("div", {
    "data-testid": type,
    className: classes
  }, animation ? /*#__PURE__*/React__default.createElement(Shimmer, null) : null);
};
Skeleton.propTypes = {
  type: PropTypes.string,
  animation: PropTypes.bool
};

const TjSkeletonText = _ref => {
  let {
    variant,
    animation
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Skeleton, {
    type: variant,
    animation: animation
  });
};
TjSkeletonText.propTypes = {
  variant: PropTypes.string,
  animation: PropTypes.bool
};

const TjSkeletonAvatar = _ref => {
  let {
    animation
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Skeleton, {
    type: "avatar",
    animation: animation
  });
};
TjSkeletonAvatar.propTypes = {
  type: PropTypes.string,
  animation: PropTypes.bool
};

/* eslint-disable camelcase */

const classNames$5 = require('classnames');
const TjDropDownContainer = _ref => {
  let {
    className,
    disabled,
    component,
    dropDownComponent,
    customTrigger = false,
    onClose
  } = _ref;
  const rootElement = useRef(null);
  const [id, setId] = useState();
  const [openPosition, setOpenPosition] = useState('');
  const [isOpen, setOpen] = useState(false);
  const [isClosed, setClose] = useState(true);
  const wrapperClass = classNames$5({
    'tj-drop-down-container': true,
    'is-open': isOpen,
    'is-close': !isOpen && isClosed,
    [className]: !!className,
    ["tj-drop-down-popover-position-".concat(openPosition)]: true,
    disabled
  });
  const popoverClass = classNames$5({
    'tj-drop-down-popover-container': true,
    animate__animated: true,
    animate__fadeIn: isOpen,
    animate__fadeOut: !isClosed && !isOpen,
    animate__faster: true
  });
  const setOpenToggle = (status, closeSilently) => {
    if (!status) {
      if (typeof onClose === 'function' && !closeSilently) {
        setTimeout(onClose, 0);
      }
    }
    setOpen(status);
    setTimeout(() => {
      setClose(!status);
      if (status && rootElement.current) {
        const element = rootElement.current.firstElementChild;
        const selectorHeight = element.offsetHeight;
        const selectYPosition = getElementOffset(element).top;
        const windowHeight = document.documentElement.clientHeight;
        const windowScrollTop = document.documentElement.scrollTop;
        const availableHeightInTop = selectYPosition - windowScrollTop;
        const availableHeightInBottom = windowHeight - (availableHeightInTop + selectorHeight);
        const listElementContainer = element.nextElementSibling;
        const listElement = listElementContainer.firstElementChild;
        const listHeight = listElement.offsetHeight;
        if (availableHeightInBottom >= listHeight || availableHeightInTop < listHeight) {
          setOpenPosition('bottom');
        } else {
          setOpenPosition('top');
        }
      }
    }, 100);
  };
  const handleClick = useCallback(function (event) {
    event.stopPropagation();
    if (disabled) {
      return false;
    }
    if (isOpen) {
      setOpenToggle(false);
      return;
    }
    setOpenToggle(true);
  }, [isOpen, rootElement, disabled, customTrigger]);
  const handleOutsideClick = useCallback(e => {
    if (!(rootElement.current && rootElement.current.contains(e.target))) {
      setOpenToggle(false);
    }
  }, []);
  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    setId(guidGenerator());
    return () => {
      var _document;
      return (_document = document) === null || _document === void 0 ? void 0 : _document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    ref: rootElement,
    "data-testid": "tj-drop-down-wrapper",
    className: wrapperClass
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "tj-drop-down-element-container",
    "data-testid": "tj-drop-down-element-container",
    role: "combobox",
    "aria-controls": "tj-drop-down-popover-container-".concat(id),
    "aria-haspopup": "listbox",
    tabIndex: 0,
    onKeyPress: event => event.key === 'Enter' ? handleClick(event) : null,
    "aria-expanded": isOpen,
    onClick: !customTrigger ? handleClick : undefined
  }, component({
    handleClick
  })), /*#__PURE__*/React__default.createElement("div", {
    className: popoverClass,
    id: "tj-drop-down-popover-container-".concat(id),
    "data-testid": "tj-drop-down-popover-test-id"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "popover-body"
  }, !disabled && isOpen ? dropDownComponent({
    setOpenToggle
  }) : null)));
};
TjDropDownContainer.propTypes = {
  component: PropTypes.func.isRequired,
  dropDownComponent: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  customTrigger: PropTypes.bool
};

const DatePicker = require('@hassanmojab/react-modern-calendar-datepicker');
const classNames$4 = require('classnames');
const BasicDatePicker = _ref => {
  let {
    name,
    locale = 'en',
    disabled,
    onChange,
    onBlur,
    value,
    maximumDate,
    minimumDate,
    selectorEndingYear,
    selectorStartingYear,
    visibleScrollBar,
    formatLangCode = 'en',
    formatOptions = {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    ...restProps
  } = _ref;
  const [inputVal, setInputVal] = useState('');
  const [isTyping, setTyping] = useState(false);
  const [isActive, setActive] = useState(false);
  const _value = useMemo(() => {
    const transformValue = value && typeof value === 'string' ? value.split('-') : value;
    if (transformValue) {
      return {
        year: parseInt(transformValue[0]),
        month: parseInt(transformValue[1]),
        day: parseInt(transformValue[2])
      };
    }
    return transformValue;
  }, [value]);
  const displayFormat = useMemo(() => {
    if (_value && typeof _value === 'object') {
      return new Date(dateFormat(_value)).toLocaleDateString(formatLangCode, formatOptions);
    }
    return '';
  }, [_value]);
  const handleInputFocus = useCallback(() => {
    setActive(true);
    setTyping(true);
    setInputVal(displayFormat);
  }, [displayFormat]);
  const handleKeyDown = useCallback(() => {
    if (!isTyping) {
      setTyping(true);
    }
  }, [isTyping]);
  const handleInputChange = useCallback(e => {
    setInputVal(e.target.value);
    const newDate = new Date(e.target.value);
    if (newDate.toString() !== 'Invalid Date') {
      const year = newDate.getFullYear();
      const month = newDate.getMonth() + 1;
      const day = newDate.getDate();
      const formattedDate = dateFormat({
        year,
        month,
        day
      });
      if (!isLegalDate(e.target.value, minimumDate, maximumDate)) {
        return;
      }
      onChange(formattedDate);
    }
  }, [onChange, minimumDate, maximumDate]);
  const handleInputBlur = useCallback(e => {
    setActive(false);
    if (typeof onBlur === 'function') {
      onBlur();
    }
    setTyping(false);
    const _val = e.target.value;
    if (!_val) {
      onChange('');
      return;
    }
    const newDate = new Date(e.target.value);
    if (newDate.toString() === 'Invalid Date') {
      onChange(dateFormat(_value));
    } else if (!isLegalDate(_val, minimumDate, maximumDate)) {
      onChange(dateFormat(_value));
    }
  }, [onChange, _value, minimumDate, maximumDate]);
  const rootElementClass = classNames$4({
    'visible-scroll-bar': visibleScrollBar,
    'is-active': isActive
  });
  return /*#__PURE__*/React__default.createElement(TjDropDownContainer, {
    className: rootElementClass,
    disabled: disabled,
    customTrigger: true,
    component: _ref2 => {
      let {
        handleClick
      } = _ref2;
      return /*#__PURE__*/React__default.createElement(BasicTextInput$1, _extends$A({}, restProps, {
        name: name,
        autoComplete: "new-password",
        value: isTyping ? inputVal : displayFormat,
        onFocus: handleInputFocus,
        onChange: handleInputChange,
        onBlur: handleInputBlur,
        onClick: handleClick,
        onKeyDown: handleKeyDown,
        disabled: disabled
      }));
    },
    onClose: () => {
      setTyping(false);
      if (typeof onBlur === 'function') {
        onBlur();
      }
    },
    dropDownComponent: _ref3 => {
      let {
        setOpenToggle
      } = _ref3;
      return /*#__PURE__*/React__default.createElement(DatePicker.Calendar, {
        value: typeof _value === 'object' ? _value : undefined,
        locale: locale,
        minimumDate: minimumDate,
        maximumDate: maximumDate,
        onChange: dateObj => {
          onChange(dateFormat(dateObj));
          setOpenToggle(false);
        },
        shouldHighlightWeekends: true,
        selectorStartingYear: selectorStartingYear,
        selectorEndingYear: selectorEndingYear
      });
    }
  });
};
function dateFormat(dateObj) {
  if (!dateObj) {
    return '';
  }
  return "".concat(dateObj.year, "-").concat(zeroPad(dateObj.month, 2), "-").concat(zeroPad(dateObj.day, 2));
}
function isLegalDate(inputDate, minimumDate, maximumDate) {
  const newDate = new Date(inputDate);
  const minDateInstance = minimumDate ? new Date(dateFormat(minimumDate)) : null;
  const maxDateInstance = maximumDate ? new Date(dateFormat(maximumDate)) : null;
  return !(minDateInstance && newDate < minDateInstance || maxDateInstance && newDate > maxDateInstance);
}
BasicDatePicker.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  locale: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  minimumDate: PropTypes.shape({
    year: PropTypes.number.isRequired,
    month: PropTypes.number.isRequired,
    day: PropTypes.number.isRequired
  }),
  maximumDate: PropTypes.shape({
    year: PropTypes.number.isRequired,
    month: PropTypes.number.isRequired,
    day: PropTypes.number.isRequired
  }),
  formatLangCode: PropTypes.string,
  formatOptions: PropTypes.shape({
    year: PropTypes.string.isRequired,
    month: PropTypes.string.isRequired,
    day: PropTypes.string.isRequired
  }),
  disabled: PropTypes.bool,
  selectorStartingYear: PropTypes.number,
  selectorEndingYear: PropTypes.number,
  visibleScrollBar: PropTypes.bool
};

const TjDatePicker = _ref => {
  let {
    name,
    label,
    required,
    validate,
    ...restProps
  } = _ref;
  const {
    input,
    meta: {
      error,
      touched,
      submitError
    }
  } = useField(name, {
    validate
  });
  return /*#__PURE__*/React__default.createElement(BasicDatePicker, _extends$A({
    name: name,
    label: label,
    required: required,
    touched: touched,
    error: touched && (error || submitError) ? error || submitError : null
  }, mergeSomeEvent(restProps, input)));
};
TjDatePicker.propTypes = {
  name: PropTypes.string,
  label: labelPropTypes.label,
  required: PropTypes.bool,
  validate: PropTypes.func
};

function isDecimalRule(value) {
  const _val = value * 1;
  const floorValue = Math.floor(_val);
  return !isNaN(floorValue) && floorValue !== _val;
}

function isEmailRule(value) {
  const val = value ? value.toString() : '';
  const re = /^[a-z\d._\-+]+@[a-z\d.-]+\.[a-z]{2,}$/gim;
  return re.test(val.toLowerCase());
}

const {
  isEmpty
} = require('lodash');
function isEmptyRule(value) {
  return isEmpty(value);
}

function isFutureDateRule(value) {
  const date = new Date(value);
  if (date.toString() === 'Invalid Date') {
    return false;
  }
  const now = new Date();
  const nowDate = new Date("".concat(now.getFullYear(), "-").concat(now.getMonth() + 1, "-").concat(now.getDate()));
  const inputDate = new Date("".concat(date.getFullYear(), "-").concat(date.getMonth() + 1, "-").concat(date.getDate()));
  return inputDate > nowDate;
}

function isIntegerRule(value) {
  const intValue = value * 1;
  return !isNaN(intValue) && Number.isInteger(intValue);
}

function isIntegerPositiveRule(value) {
  const intValue = value * 1;
  return isIntegerRule(intValue) && intValue >= 0;
}

function isLowerCaseRule(value) {
  return value.toString().toLowerCase() === value.toString();
}

function isMaxLengthRule(value, _ref) {
  let {
    max
  } = _ref;
  return isArray$1(value) ? value.length <= max : String(value).length <= max;
}

function isMaxNumberRule(value, _ref) {
  let {
    max
  } = _ref;
  const val = value * 1;
  return !isNaN(val) && val <= max;
}

function isMinLengthRule(value, _ref) {
  let {
    min
  } = _ref;
  return isArray$1(value) ? value.length >= min : String(value).length >= min;
}

function isMinNumberRule(value, _ref) {
  let {
    min
  } = _ref;
  const val = value * 1;
  return !isNaN(val) && val >= min;
}

function isNoSpaceRule(value) {
  return !value.toString().includes(' ');
}

function isNoSpecialCharactersRule(value) {
  const val = value ? value.toString() : '';
  const regx = new RegExp(/^[0-9a-z]+$/i);
  return regx.test(val);
}

function isNoZeroRule(value) {
  return !value.toString().includes('0');
}

function isPastDateRule(value) {
  const date = new Date(value);
  if (date.toString() === 'Invalid Date') {
    return false;
  }
  const now = new Date();
  const nowDate = new Date("".concat(now.getFullYear(), "-").concat(now.getMonth() + 1, "-").concat(now.getDate()));
  const inputDate = new Date("".concat(date.getFullYear(), "-").concat(date.getMonth() + 1, "-").concat(date.getDate()));
  return inputDate < nowDate;
}

const tjValidate = (value, isVisible, rules, messageFormatter) => {
  const val = value ? value : '';
  const format = (error, attr) => typeof messageFormatter === 'function' ? messageFormatter(error, attr) : error;
  if (!isVisible || !rules) {
    return;
  }
  if ((rules.includes('must') || rules.includes('required')) && isEmptyRule(value)) {
    return format('required');
  }

  // When Field is not required and don't have any value.

  if (!val) {
    return;
  }
  if (rules.includes('errorDecimal') && !isDecimalRule(val)) {
    return format('errorDecimal');
  }
  if (rules.includes('errorInteger') && !isIntegerRule(val)) {
    return format('errorInteger');
  }
  if (rules.includes('errorIntegerPositive') && !isIntegerPositiveRule(val)) {
    return format('errorIntegerPositive');
  }
  if (rules.includes('errorNoZero') && !isNoZeroRule(val)) {
    return format('errorNoZero');
  }
  if (rules.includes('errorLowerCase') && !isLowerCaseRule(val)) {
    return format('errorLowerCase');
  }
  if (rules.includes('errorNoSpace') && !isNoSpaceRule(val)) {
    return format('errorNoSpace');
  }
  if (rules.includes('errorNoSpecialCharacters') && !isNoSpecialCharactersRule(val)) {
    return format('errorNoSpecialCharacters');
  }
  if (rules.includes('errorEmail') && !isEmailRule(val)) {
    return format('errorEmail');
  }
  if (rules.includes('noFutureDate') && isFutureDateRule(val)) {
    return format('noFutureDate');
  }
  if (rules.includes('noPastDate') && isPastDateRule(val)) {
    return format('noPastDate');
  }
  const maxLength = hasLengthRule(rules, 'errorMaxLength');
  if (maxLength !== null && !isMaxLengthRule(val, {
    max: maxLength
  })) {
    return format('errorMaxLength', {
      max: maxLength
    });
  }
  const minLength = hasLengthRule(rules, 'errorMinLength');
  if (minLength !== null && !isMinLengthRule(val, {
    min: minLength
  })) {
    return format('errorMinLength', {
      min: minLength
    });
  }
  const maxNumber = hasLengthRule(rules, 'errorMaxNumber');
  if (maxNumber !== null && !isMaxNumberRule(val, {
    max: maxNumber
  })) {
    return format('errorMaxNumber', {
      max: maxNumber
    });
  }
  const minNumber = hasLengthRule(rules, 'errorMinNumber');
  if (minNumber !== null && !isMinNumberRule(val, {
    min: minNumber
  })) {
    return format('errorMinNumber', {
      min: minNumber
    });
  }
  return;
};
const hasLengthRule = (rules, expectedRule) => {
  const index = rules.findIndex(r => r.toString().startsWith(expectedRule));
  if (index === -1) {
    return null;
  }
  const rule = rules[index];
  const match = rule.match(/\[([0-9])\]/);

  // NOt a valid rule
  if (!match) {
    return null;
  }
  return parseInt(match[1]);
};

const TjInputWrapper = _ref => {
  let {
    isVisible,
    name,
    rules,
    component,
    required,
    messageFormatter,
    autoManageRequired = true,
    ...restProps
  } = _ref;
  const form = useForm('validation');
  useEffect(() => {
    const unsubscribe = form.registerField(name, () => {}, {
      value: true
    }, {
      getValidator: () => {
        return value => {
          const output = tjValidate(value, isVisible, rules, messageFormatter);
          return output;
        };
      }
    });
    return unsubscribe;
  }, [isVisible, rules ? rules.join(',') : '']);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: isVisible ? 'block' : 'none'
    }
  }, /*#__PURE__*/React__default.createElement(BlankInputWithInitialValue, {
    name: "fieldVisibility.".concat(name),
    initialValue: isVisible
  }), /*#__PURE__*/React__default.createElement(component, {
    ...restProps,
    name,
    required: autoManageRequired && rules && (rules.includes('must') || rules.includes('required')) || required
  }));
};
const BlankInputWithInitialValue = _ref2 => {
  let {
    name,
    initialValue
  } = _ref2;
  useField(name);
  const form = useForm();
  useEffect(() => {
    form.change(name, initialValue);
  }, [initialValue]);
  return null;
};
BlankInputWithInitialValue.propTypes = {
  name: PropTypes.string,
  initialValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool])
};
TjInputWrapper.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  required: PropTypes.bool,
  name: PropTypes.string.isRequired,
  rules: PropTypes.arrayOf(PropTypes.string),
  component: PropTypes.elementType.isRequired,
  messageFormatter: PropTypes.func,
  autoManageRequired: PropTypes.bool
};

const TjTag = _ref => {
  let {
    status,
    label
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "tj-tag-component"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "dot dot-".concat(status)
  }), /*#__PURE__*/React__default.createElement("span", null, label)));
};
TjTag.propTypes = {
  status: PropTypes.string,
  label: PropTypes.string
};

const TjStepsContext = /*#__PURE__*/React__default.createContext();
const TjSteps = _ref => {
  let {
    children,
    activeTab,
    enabledWhenDone = true,
    disabledAllAtLastStep = true
  } = _ref;
  const location = useLocation();
  const {
    stepOrders,
    activeStep
  } = useMemo(() => {
    const data = {
      stepOrders: {},
      activeStep: null
    };
    isArray(children) && children.forEach((elm, index) => {
      const number = index + 1;
      const name = elm.props.name;
      const to = elm.props.to;
      data.stepOrders[name] = number;
      const match = matchPath(location.pathname, {
        path: to,
        strict: true,
        sensitive: true,
        exact: true
      });
      const isActive = !to ? activeTab === name : match;
      if (isActive) {
        data.activeStep = number;
      }
    });
    return data;
  }, [children, location === null || location === void 0 ? void 0 : location.pathname, activeTab]);
  const lastNumber = children && isArray(children) ? children.length : null;
  return /*#__PURE__*/React__default.createElement(TjStepsContext.Provider, {
    value: {
      activeTab,
      stepOrders,
      activeStep,
      enabledWhenDone,
      lastNumber,
      disabledAllAtLastStep
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "tj-steps-container  secondary-font-color"
  }, children));
};
TjSteps.propTypes = {
  enabledWhenDone: PropTypes.bool,
  disabledAllAtLastStep: PropTypes.bool,
  children: (props, propName, componentName) => {
    const expectedLength = 2;
    const propValue = props[propName];
    if (isEmpty$1(propValue)) {
      return new Error("Invalid ".concat(propName, " prop (expected array length ").concat(expectedLength, ") for prop ").concat(propName, " supplied to ").concat(componentName, ". Validation failed.1"));
    }
    if (!isArray(propValue)) {
      return new Error("Invalid ".concat(propName, " prop (expected a array for prop ").concat(propName, " supplied to ").concat(componentName, ". Validation failed.2"));
    }
    const arrayPropLength = propValue.length;
    if (arrayPropLength < expectedLength) {
      return new Error("Invalid array length ".concat(arrayPropLength, " (expected ").concat(expectedLength, ") for prop ").concat(propName, " supplied to ").concat(componentName, ". Validation failed.3"));
    }
  },
  activeTab: PropTypes.string
};

const classNames$3 = require('classnames');
const TjStep = _ref => {
  let {
    name,
    to,
    title,
    disabled,
    onClick
  } = _ref;
  const {
    stepOrders,
    activeStep,
    enabledWhenDone,
    disabledAllAtLastStep,
    lastNumber
  } = useContext(TjStepsContext);
  const isActive = stepOrders[name] === activeStep;
  const isDone = stepOrders[name] < activeStep;
  const _disabled = disabled || !isDone && enabledWhenDone || disabledAllAtLastStep && lastNumber === activeStep;
  const rootElemClassNames = classNames$3({
    'tj-step-item-container': true,
    'is-active highlight-color': isActive,
    'highlight-on-hover': !_disabled,
    disabled: _disabled
  });
  const linkClassNames = classNames$3({
    'step-link': true,
    'highlight-on-hover': !isActive && !_disabled
  });
  const preventLinkClick = _disabled ? e => e.preventDefault() : undefined;
  const a11yStepAttributes = {
    ...(!_disabled && !to && {
      role: 'button',
      tabIndex: 0
    }),
    ...(!_disabled && {
      onKeyPress: e => !_disabled && e.key === 'Enter' ? onClick(e) : null,
      onClick
    })
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: rootElemClassNames,
    "data-testid": "tj-step-container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "tj-step-number-wrapper"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "tj-step-line left bg-gradient"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "opacity-mask"
  })), /*#__PURE__*/React__default.createElement("span", {
    className: "tj-step-number bg-gradient"
  }, /*#__PURE__*/React__default.createElement("svg", {
    className: "circle",
    height: "20",
    width: "20"
  }, /*#__PURE__*/React__default.createElement("circle", {
    cx: "10",
    cy: "10",
    r: "9",
    stroke: "white",
    strokeOpacity: "0%",
    strokeWidth: "1",
    fill: "#f0f6ff"
  })), /*#__PURE__*/React__default.createElement("span", {
    className: "tj-step-bg-overlay tj-step-number-box"
  }, stepOrders[name]), /*#__PURE__*/React__default.createElement("span", {
    className: "tj-step-bg-overlay highlight-color tj-step-done-mark"
  }, /*#__PURE__*/React__default.createElement(Icons.CheckMark, null))), /*#__PURE__*/React__default.createElement("span", {
    className: "tj-step-line right bg-gradient"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "opacity-mask "
  }))), /*#__PURE__*/React__default.createElement("div", _extends$A({
    "data-testid": "action-elm",
    title: title
  }, a11yStepAttributes, {
    className: "tj-step-link-wrapper ".concat(_disabled ? 'disabled' : '')
  }), to ? /*#__PURE__*/React__default.createElement(Link, {
    "data-testid": "anchor-elm",
    onClick: preventLinkClick,
    className: linkClassNames,
    to: to
  }, /*#__PURE__*/React__default.createElement(PrintTitle, {
    title: title
  })) : /*#__PURE__*/React__default.createElement("span", {
    className: linkClassNames
  }, /*#__PURE__*/React__default.createElement(PrintTitle, {
    title: title
  }))));
};
const PrintTitle = _ref2 => {
  let {
    title
  } = _ref2;
  const [_title, setTitle] = useState([]);
  useEffect(() => {
    setTitle(breakWord(title));
  }, [title]);
  return _title.map(str => {
    return [...str.map((_str, index) => /*#__PURE__*/React__default.createElement("font", {
      key: "".concat(_str, "_").concat(index)
    }, _str)), ' '];
  });
};
TjStep.propTypes = {
  to: PropTypes.string,
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onClick: PropTypes.func
};

const TjSpinner = () => {
  return /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "spinner-wrapper",
    className: "wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "spinner"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "spinner-inner-circle"
  }));
};

const RawToggleSwitch = _ref => {
  let {
    dataTestid = 'raw-toggle-checkbox',
    ...props
  } = _ref;
  return /*#__PURE__*/React__default.createElement(RawTextInput$1, _extends$A({}, props, {
    "data-testid": dataTestid,
    tabIndex: 0,
    "aria-checked": props.checked ? 'true' : 'false',
    type: "checkbox"
  }));
};
RawToggleSwitch.propTypes = {
  dataTestid: PropTypes.string,
  checked: PropTypes.bool
};

const classNames$2 = require('classnames');
const BasicToggleSwitch = _ref => {
  let {
    id,
    name,
    checked,
    onChange,
    disabled,
    label,
    required,
    ...restProps
  } = _ref;
  function handleKeyPress(e) {
    if (e.keyCode !== 32) return;
    e.preventDefault();
    onChange(!checked);
  }
  const labelClass = classNames$2({
    'form-check-label': true,
    'tj-radio-checkbox-label': true,
    disabled
  });
  const toggleClass = classNames$2({
    'toggle-switch-checkbox': true
  });
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: "toggle-switch small-switch"
  }, /*#__PURE__*/React__default.createElement(RawToggleSwitch, _extends$A({
    id: id,
    name: name,
    disabled: disabled,
    "data-testid": "toggle-checkbox",
    className: toggleClass,
    checked: checked,
    onChange: e => onChange(e.target.checked)
  }, restProps)), id ? /*#__PURE__*/React__default.createElement("span", {
    role: "button",
    className: "toggle-switch-label",
    onClick: () => !disabled ? onChange(!checked) : null,
    tabIndex: disabled ? -1 : undefined,
    "data-testid": "toggle-checkbox-label",
    onKeyDown: e => !disabled ? handleKeyPress(e) : null,
    "aria-label": label
  }, /*#__PURE__*/React__default.createElement("span", {
    className: disabled ? 'toggle-switch-inner toggle-switch-disabled' : 'toggle-switch-inner',
    tabIndex: -1
  }), /*#__PURE__*/React__default.createElement("span", {
    className: disabled ? 'toggle-switch-switch toggle-switch-disabled' : 'toggle-switch-switch',
    tabIndex: -1
  })) : null), label && /*#__PURE__*/React__default.createElement(Label, {
    htmlFor: id,
    label: label,
    disabled: disabled,
    className: labelClass,
    required: required
  }));
};
BasicToggleSwitch.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  label: labelPropTypes.label,
  required: PropTypes.bool
};

const TjToggleSwitch = _ref => {
  let {
    name,
    label,
    required,
    value,
    validate,
    ...restProps
  } = _ref;
  const {
    input
  } = useField(name, {
    type: 'checkbox',
    value,
    validate,
    multiple: false
  });
  return /*#__PURE__*/React__default.createElement(BasicToggleSwitch, _extends$A({
    label: label,
    required: required,
    name: name
  }, mergeSomeEvent(restProps, input)));
};
TjToggleSwitch.propTypes = {
  name: PropTypes.string.isRequired,
  label: labelPropTypes.label,
  required: PropTypes.bool,
  value: PropTypes.string,
  validate: PropTypes.func
};

const JobSubtitle = _ref => {
  let {
    items
  } = _ref;
  return items.length ? /*#__PURE__*/React__default.createElement("ul", {
    className: "tag-list secondary-font-color"
  }, items.map(item => {
    var _item$title, _item$title2;
    return /*#__PURE__*/React__default.createElement(JobSubtitleItem, {
      key: (_item$title = item === null || item === void 0 ? void 0 : item.title) !== null && _item$title !== void 0 ? _item$title : item,
      title: (_item$title2 = item === null || item === void 0 ? void 0 : item.title) !== null && _item$title2 !== void 0 ? _item$title2 : item,
      to: item === null || item === void 0 ? void 0 : item.to
    });
  })) : null;
};
JobSubtitle.propTypes = {
  items: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    to: PropTypes.string
  })), PropTypes.arrayOf(PropTypes.string)])
};
const JobSubtitleItem = _ref2 => {
  let {
    to,
    title
  } = _ref2;
  return /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("span", {
    className: "dot secondary-font-color"
  }, "."), to ? /*#__PURE__*/React__default.createElement(Link, {
    "data-testid": title,
    to: to
  }, title) : /*#__PURE__*/React__default.createElement("span", null, title));
};
JobSubtitleItem.propTypes = {
  title: PropTypes.string.isRequired,
  to: PropTypes.string
};

const RawAvatar = _ref => {
  let {
    dataTestid = 'raw-avatar',
    avatarTitle,
    avatarUrl,
    avatarSize = 56
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", {
    "data-testid": dataTestid,
    className: "avatar-outer-circle",
    style: {
      height: "".concat(avatarSize, "px"),
      width: "".concat(avatarSize, "px"),
      lineHeight: "".concat(avatarSize, "px")
    }
  }, avatarUrl ? /*#__PURE__*/React__default.createElement("div", {
    className: "avatar-imgouter-circle-white",
    style: {
      height: "".concat(avatarSize, "px"),
      width: "".concat(avatarSize, "px"),
      lineHeight: "".concat(avatarSize, "px")
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    "data-testid": "avatar-img",
    className: "avatarimage",
    alt: avatarTitle,
    style: {
      height: "".concat(avatarSize, "px")
    },
    src: avatarUrl
  })) : /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: "avatar-outer-circle-white",
    style: {
      height: "".concat(avatarSize, "px"),
      width: "".concat(avatarSize, "px"),
      lineHeight: "".concat(avatarSize, "px")
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "avatar-title-conatainer",
    style: {
      height: "".concat(avatarSize, "px"),
      width: "".concat(avatarSize, "px")
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "avatar-title"
  }, avatarTitle))), /*#__PURE__*/React__default.createElement("div", {
    className: avatarUrl ? 'avatar-inner-circle-borderless' : 'avatar-inner-circle'
  }));
};
RawAvatar.propTypes = {
  dataTestid: PropTypes.string,
  avatarTitle: PropTypes.string,
  avatarUrl: PropTypes.string,
  avatarSize: PropTypes.number
};

const BasicAvatar = _ref => {
  let {
    id,
    name,
    avatarTitle,
    avatarUrl,
    avatarSize
  } = _ref;
  return /*#__PURE__*/React__default.createElement(RawAvatar, {
    id: id,
    name: name,
    avatarTitle: getShortTitle(avatarTitle),
    avatarUrl: avatarUrl,
    avatarSize: avatarSize
  });
};
function getShortTitle(avatarTitle) {
  const firstLetters = avatarTitle.split(/[-_ ]+/).slice(0, 3).map(word => word[0]).join('');
  return firstLetters.toUpperCase();
}
BasicAvatar.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  avatarTitle: PropTypes.string.isRequired,
  avatarUrl: PropTypes.string,
  avatarSize: PropTypes.number
};

const TjAvatar = _ref => {
  let {
    name,
    avatarTitle,
    avatarUrl,
    avatarSize,
    ...restProps
  } = _ref;
  return /*#__PURE__*/React__default.createElement(BasicAvatar, _extends$A({
    name: name,
    avatarTitle: avatarTitle,
    avatarUrl: avatarUrl,
    avatarSize: avatarSize
  }, restProps));
};
TjAvatar.propTypes = {
  name: PropTypes.string,
  avatarTitle: PropTypes.string.isRequired,
  avatarUrl: PropTypes.string,
  avatarSize: PropTypes.number
};

const classNames$1 = require('classnames');
const TjJobCard = _ref => {
  let {
    title,
    subtitle,
    jobLink,
    description,
    applyLink,
    applyBtnLabel = 'Apply',
    viewMoreLabel = 'View More',
    searchQuery = '',
    avatarImgUrl,
    avatarSize
  } = _ref;
  const [isExpanded, setExpanded] = useState(false);
  const [hasFocus, setHasFocus] = useState(false);
  const history = useHistory();
  const rootElmClass = classNames$1({
    card: true,
    'tj-job-card': true,
    expanded: isExpanded,
    hasFocus
  });
  const handleJobLinkClick = useCallback(e => {
    e.stopPropagation();
    e.preventDefault();
    jobLink(e);
  });
  const handleApplyBtnClick = useCallback(e => {
    e.stopPropagation();
    if (typeof applyLink === 'function') {
      applyLink(e);
    } else {
      history.push(applyLink);
    }
  }, [applyLink]);
  const bindLongPress = useLongPress(e => {
    e.stopPropagation();
    setExpanded(!isExpanded);
  }, {
    threshold: 500,
    captureEvent: true,
    cancelOnMovement: false,
    detect: 'both'
  });
  return /*#__PURE__*/React__default.createElement("div", _extends$A({
    "data-testid": "job-card-elm",
    className: rootElmClass
  }, bindLongPress), /*#__PURE__*/React__default.createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "job-short-info-row"
  }, /*#__PURE__*/React__default.createElement(TjAvatar, {
    avatarTitle: title,
    avatarUrl: avatarImgUrl,
    avatarSize: avatarSize
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "title-col"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "row flex-column"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "col"
  }, typeof jobLink === 'function' ? /*#__PURE__*/React__default.createElement("div", {
    role: "button",
    className: "link",
    tabIndex: 0,
    onClick: handleJobLinkClick,
    onKeyPress: event => event.key === 'Enter' ? handleJobLinkClick(event) : null,
    "data-testid": "job-title-a",
    onFocus: () => setHasFocus(true)
  }, /*#__PURE__*/React__default.createElement(BoldText, {
    text: title,
    searchQuery: searchQuery
  })) : /*#__PURE__*/React__default.createElement(Link, {
    className: "primary-font-color",
    to: jobLink,
    "data-testid": "job-title-link",
    onClick: e => e.stopPropagation(),
    onFocus: () => setHasFocus(true)
  }, /*#__PURE__*/React__default.createElement(BoldText, {
    text: title,
    searchQuery: searchQuery
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "col subtitle-col"
  }, /*#__PURE__*/React__default.createElement(JobSubtitle, {
    items: subtitle
  })))), applyLink ? /*#__PURE__*/React__default.createElement("div", {
    className: "col action-col"
  }, /*#__PURE__*/React__default.createElement(TjButton, {
    "data-testid": "job-apply-btn",
    type: "button",
    onClick: handleApplyBtnClick
  }, applyBtnLabel)) : null), /*#__PURE__*/React__default.createElement("div", {
    className: "row job-mobile-job-subtitle"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "col subtitle-col"
  }, /*#__PURE__*/React__default.createElement(JobSubtitle, {
    items: subtitle
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "row flex-column description-row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "col description-col"
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "primary-font-color",
    "data-testid": "job-description"
  }, description)), /*#__PURE__*/React__default.createElement("div", {
    className: "col description-col d-flex justify-content-center"
  }, typeof jobLink === 'function' ? /*#__PURE__*/React__default.createElement("div", {
    role: "button",
    className: "link",
    tabIndex: 0,
    onClick: handleJobLinkClick,
    onKeyPress: event => event.key === 'Enter' ? handleJobLinkClick(event) : null,
    "data-testid": "view-more-btn",
    onBlur: () => setHasFocus(false)
  }, viewMoreLabel) : /*#__PURE__*/React__default.createElement(Link, {
    to: jobLink,
    "data-testid": "view-more-btn-link",
    onClick: e => e.stopPropagation(),
    onBlur: () => setHasFocus(false)
  }, viewMoreLabel, /*#__PURE__*/React__default.createElement("span", {
    className: "link-icon"
  }, /*#__PURE__*/React__default.createElement(Icons.DropdownArrowBack, null)))))));
};
const BoldText = _ref2 => {
  let {
    text,
    searchQuery
  } = _ref2;
  const textArray = text ? text.split(' ') : [''];
  const searchParts = searchQuery ? searchQuery.split(' ') : [''];
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, textArray.map((word, i) => /*#__PURE__*/React__default.createElement("span", {
    key: i,
    className: searchParts.includes(word) ? 'is-bold' : ''
  }, "".concat(word, " "))));
};
TjJobCard.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]).isRequired,
  subtitle: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    to: PropTypes.string
  })), PropTypes.arrayOf(PropTypes.string)]),
  jobLink: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  applyLink: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  description: PropTypes.string,
  applyBtnLabel: PropTypes.string,
  viewMoreLabel: PropTypes.string,
  searchQuery: PropTypes.string,
  avatarSize: PropTypes.number,
  avatarImgUrl: PropTypes.string
};
BoldText.propTypes = {
  text: PropTypes.string.isRequired,
  searchQuery: PropTypes.string
};

const classNames = require('classnames');
const TjSidebarNav = _ref => {
  let {
    isDefaultExpanded = true,
    render,
    ...restProps
  } = _ref;
  const [isExpanded, setExpand] = useState(isDefaultExpanded);
  const rootElmClass = classNames({
    'tj-navbar-container': true,
    expanded: isExpanded,
    collapsed: !isExpanded
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: rootElmClass,
    "data-testid": "tj-sidebar-navigation-container"
  }, /*#__PURE__*/React__default.createElement("button", {
    onClick: () => setExpand(!isExpanded),
    type: "button",
    "data-testid": "tj-sidebar-navigation-toggle-btn",
    className: "highlight-color toggle-btn application-bg-color"
  }, /*#__PURE__*/React__default.createElement(Icons.NavigationBack, null)), /*#__PURE__*/React__default.createElement("div", {
    className: "tj-navbar-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "tj-navbar-content",
    "data-testid": "tj-sidebar-navigation-content"
  }, /*#__PURE__*/React__default.createElement(render, {
    ...restProps,
    isExpanded,
    setExpand
  }))));
};
TjSidebarNav.propTypes = {
  render: PropTypes.elementType.isRequired,
  isDefaultExpanded: PropTypes.bool
};

const TjBottomSheet = _ref => {
  let {
    btnRender,
    renderContent
  } = _ref;
  const [isOpen, setOpen] = useState(false);
  const [showCloseAnimation, setShowCloseAnimation] = useState(false);
  const close = useCallback(() => {
    setShowCloseAnimation(true);
    setTimeout(() => {
      setOpen(false);
      setShowCloseAnimation(false);
    }, 500);
  }, []);
  const handleBackClick = useCallback(() => {
    close();
  }, []);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(btnRender, {
    open: () => setOpen(true),
    isOpen
  }), isOpen ? /*#__PURE__*/React__default.createElement("div", {
    className: "back-drop",
    "data-testid": "tj-bottom-sheet-backdrop"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "tj-bottom-sheet-wrapper",
    "data-testid": "tj-bottom-sheet-wrapper",
    role: "button",
    tabIndex: -1,
    onKeyPress: event => event.key === 'Enter' ? handleBackClick(event) : null,
    onClick: handleBackClick
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "animate__animated animate__faster ".concat(showCloseAnimation ? 'animate__slideOutDown' : 'animate__slideInUp', " tj-bottom-sheet-content"),
    "data-testid": "tj-bottom-sheet-content",
    role: "button",
    tabIndex: -1,
    onKeyPress: e => e.stopPropagation(),
    onClick: e => e.stopPropagation()
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "tj-bottom-sheet-body"
  }, /*#__PURE__*/React__default.createElement(renderContent, {
    close
  }))))) : null);
};
TjBottomSheet.propTypes = {
  btnRender: PropTypes.elementType.isRequired,
  renderContent: PropTypes.elementType.isRequired
};

const NextBtn = _ref => {
  let {
    isHide,
    onClick,
    isDisabled
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "carousel-arrow-btn-wrapper right ".concat(isHide ? 'hidden' : ''),
    "data-testid": "carousel-arrow-next-btn-wrapper"
  }, /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    disabled: isDisabled,
    "data-testid": "carousel-next-btn",
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement(Icons.NavigationBackBold, {
    className: "highlight-color"
  })));
};
NextBtn.propTypes = {
  isHide: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func
};

const PrevBtn = _ref => {
  let {
    isHide,
    onClick,
    isDisabled
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "carousel-arrow-btn-wrapper left ".concat(isHide ? 'hidden' : ''),
    "data-testid": "carousel-arrow-prev-btn-wrapper"
  }, /*#__PURE__*/React__default.createElement("button", {
    disabled: isDisabled,
    type: "button",
    "data-testid": "carousel-prev-btn",
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement(Icons.NavigationBackBold, {
    className: "highlight-color"
  })));
};
PrevBtn.propTypes = {
  isHide: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func
};

const TjCarouselContext = /*#__PURE__*/React__default.createContext();

const makeDisableForAWhile = (setDisable, speed) => {
  setDisable(true);
  setTimeout(() => {
    setDisable(false);
  }, speed);
};
const shouldNextBtnDisappear = (items, containerWidth) => {
  const totalItem = items.length;
  const lastItem = items[totalItem - 1];
  const lastItemEndPosition = lastItem.offsetLeft + lastItem.clientWidth;
  return lastItemEndPosition <= containerWidth;
};
const getNextSlidePosition = _ref => {
  let {
    items,
    containerWidth,
    lastItemGutter
  } = _ref;
  const totalItem = items.length;
  const lastItem = items[totalItem - 1];
  const width = containerWidth;
  let done = false;
  let shouldMove = false;
  let isLastSlide = false;
  let moveTox = 0;
  items.forEach(item => {
    if (done) {
      return;
    }
    const itemStartPosition = item.offsetLeft;
    const itemGapFromLeft = itemStartPosition + item.clientWidth;
    shouldMove = itemGapFromLeft > width;
    if (shouldMove) {
      done = true;
      const lastItemPositionWillBe = lastItem.offsetLeft - itemStartPosition + lastItem.clientWidth;
      isLastSlide = lastItemPositionWillBe <= width;
      const lastMargin = itemStartPosition - (width - lastItemPositionWillBe);
      moveTox = isLastSlide ? lastMargin + lastItemGutter : itemStartPosition;
    }
  });
  return {
    shouldMove,
    isLastSlide,
    moveTox
  };
};

const TjCarousel = _ref => {
  let {
    children,
    gutter = 10,
    speed = 500,
    lastItemGutter = 10
  } = _ref;
  const element = useRef(null);
  const wrapperElement = useRef(null);
  const sliderPath = useRef([]);
  const [marginLeft, setMarginLeft] = useState(-gutter / 2);
  const [isDisabled, setDisable] = useState(false);
  const [isNextDisabled, setNextDisable] = useState(false);
  const [isPrevDisabled, setPrevDisable] = useState(true);
  const [containerWidth, setContainerWidth] = useState(0);
  const makeDisable = makeDisableForAWhile.bind(undefined, setDisable, speed);
  useEffect(() => {
    const handleWindowSize = () => {
      var _element$current2;
      setTimeout(() => {
        var _wrapperElement$curre, _element$current;
        setNextDisable(shouldNextBtnDisappear((_wrapperElement$curre = wrapperElement.current) === null || _wrapperElement$curre === void 0 ? void 0 : _wrapperElement$curre.childNodes, (_element$current = element.current) === null || _element$current === void 0 ? void 0 : _element$current.clientWidth));
      }, 100);
      sliderPath.current = [];
      setMarginLeft(-gutter / 2);
      setNextDisable(true);
      setPrevDisable(true);
      setContainerWidth((_element$current2 = element.current) === null || _element$current2 === void 0 ? void 0 : _element$current2.clientWidth);
    };
    handleWindowSize();
    window.addEventListener('resize', handleWindowSize);
    return () => {
      window.removeEventListener('resize', handleWindowSize);
    };
  }, [children.length]);
  const handleNext = () => {
    var _wrapperElement$curre2, _element$current3;
    makeDisable();
    const {
      shouldMove,
      isLastSlide,
      moveTox
    } = getNextSlidePosition({
      items: (_wrapperElement$curre2 = wrapperElement.current) === null || _wrapperElement$curre2 === void 0 ? void 0 : _wrapperElement$curre2.childNodes,
      containerWidth: (_element$current3 = element.current) === null || _element$current3 === void 0 ? void 0 : _element$current3.clientWidth,
      lastItemGutter
    });
    if (shouldMove) {
      setPrevDisable(false);
      setNextDisable(isLastSlide);
      sliderPath.current.push(moveTox);
      setMarginLeft(marginLeft - moveTox);
    }
  };
  const handlePrev = () => {
    makeDisable();
    const [marginAmount] = sliderPath.current.splice(-1);
    if (marginAmount) {
      if (isNextDisabled) {
        setNextDisable(false);
      }
      setPrevDisable(sliderPath.current.length === 0);
      setMarginLeft(marginLeft + marginAmount);
    }
  };
  const _isPrevDisabled = isDisabled || isPrevDisabled;
  const _isNextDisabled = isDisabled || isNextDisabled;
  return /*#__PURE__*/React__default.createElement(TjCarouselContext.Provider, {
    value: {
      containerWidth,
      gutter
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: element,
    className: "tj-carousel-container"
  }, /*#__PURE__*/React__default.createElement(PrevBtn, {
    isHide: isPrevDisabled,
    isDisabled: _isPrevDisabled,
    onClick: handlePrev
  }), /*#__PURE__*/React__default.createElement("div", {
    ref: wrapperElement,
    className: "tj-carousel-wrapper",
    style: {
      marginLeft: "".concat(marginLeft, "px"),
      transition: "".concat(speed, "ms")
    }
  }, children), /*#__PURE__*/React__default.createElement(NextBtn, {
    isHide: isNextDisabled,
    isDisabled: _isNextDisabled,
    onClick: handleNext
  })));
};
TjCarousel.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element]),
  gutter: PropTypes.number,
  speed: PropTypes.number,
  lastItemGutter: PropTypes.number
};

const TjCarouselItem = _ref => {
  let {
    children
  } = _ref;
  const {
    containerWidth,
    gutter
  } = useContext(TjCarouselContext);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      maxWidth: containerWidth,
      overflow: 'hidden',
      display: 'flex',
      width: 'auto',
      margin: "0 ".concat(gutter / 2, "px")
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "carousel-item",
    className: "item"
  }, children));
};
TjCarouselItem.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element])
};

const TjJobCardSkeleton = () => {
  return /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "job-card-loading",
    className: "tj-job-card-loading"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "job-loading-row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "job-loading-text-col"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "job-loading-title"
  }, /*#__PURE__*/React__default.createElement(Skeleton, {
    type: "job-card-title",
    animation: true
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "job-loading-subtitle-background"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "job-loading-subtitle"
  }, /*#__PURE__*/React__default.createElement(Skeleton, {
    type: "job-card-subtitle",
    animation: true
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "job-loading-button"
  }, /*#__PURE__*/React__default.createElement(Skeleton, {
    type: "job-card-button",
    animation: true
  })))));
};

const TjFilterTag = _ref => {
  let {
    label,
    onClick
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "tj-filter-tag-container"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "primary-font-color"
  }, label), /*#__PURE__*/React__default.createElement("button", {
    onClick: onClick,
    className: "cross-btn primary-font-color highlight-on-hover",
    "data-testid": "tj-filter-tag-close-button",
    type: "button",
    "aria-label": label
  }, /*#__PURE__*/React__default.createElement(Icons.DropdownCross, null)));
};
TjFilterTag.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func
};

const TjIcon = _ref => {
  let {
    icon
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "tj-icon-".concat(icon),
    className: "tj-icon"
  }, /*#__PURE__*/React__default.createElement(Icons[icon], {
    className: 'highlight-color'
  }));
};
TjIcon.propTypes = {
  icon: PropTypes.string.isRequired,
  label: PropTypes.string
};

const mutators = {
  fileMutators
};

export { BasicAvatar, BasicCheckbox, BasicColorPicker, BasicDatePicker, BasicFileUpload, BasicPasswordInput, BasicRadioButton, BasicSelect, BasicTextArea, BasicTextInput$1 as BasicTextInput, BasicToggleSwitch, FeedbackMessage, Label, RawColorPicker, RawFileUpload, RawPasswordInput, RawSelect, RawTextArea, RawTextInput$1 as RawTextInput, Icons as SvgIcons, TjAvatar, TjBottomSheet, TjButton, TjCarousel, TjCarouselItem, TjCheckbox, TjColorPicker, TjDatePicker, TjDropDownItem, TjDropDownList, TjError, TjFileList, TjFilePreview, TjFileSelectorApplicationForm, TjFileSelectorDesktopVersion, TjFileSelectorMobileVersion, TjFileUpload, TjFilterTag, TjIcon, TjInputWrapper, TjJobCard, TjJobCardSkeleton, TjNotificationContext, TjNotificationProvider, TjPasswordInput, TjProgressBar, TjRadioButton, TjSelect, TjSidebarNav, TjSkeletonAvatar, TjSkeletonText, TjSpinner, TjStep, TjSteps, TjTag, TjTextArea, TjTextInput, TjToggleSwitch, TjTooltip, apiMessageTransform, fileConfig, mutators, validateFormValues };
